var _defs, _g, _g2, _g3, _g4, _g5, _g6, _path, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _path2, _path3, _g33, _path4, _g34, _path5, _path6, _path7, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _g102, _g103, _g104, _g105, _g106, _g107, _g108, _g109, _g110, _g111, _g112, _g113, _g114, _g115, _g116, _g117, _g118, _g119, _g120, _g121, _g122, _g123, _g124, _g125, _g126, _g127, _g128, _g129, _g130, _g131, _g132, _g133, _g134, _g135, _g136, _g137, _g138, _g139, _g140, _g141, _g142, _g143, _g144, _g145, _g146, _g147, _g148, _g149, _g150, _g151, _g152, _g153, _g154, _g155, _g156, _g157, _g158, _g159, _g160, _g161, _g162, _g163, _g164, _g165, _g166, _g167, _g168, _g169, _g170, _g171, _g172, _g173, _g174, _g175, _g176, _g177, _g178, _g179, _g180, _g181, _g182, _g183, _g184, _g185, _g186, _g187, _g188, _g189, _g190, _g191, _g192, _g193, _g194, _g195, _g196, _g197, _g198, _g199, _g200, _g201, _g202, _g203, _g204, _g205, _g206, _g207, _g208, _g209, _g210, _g211, _g212, _g213, _g214, _g215, _g216, _g217, _g218, _g219, _g220, _g221, _g222, _g223, _g224, _g225, _g226, _g227, _g228, _g229, _g230, _g231, _g232, _g233, _g234, _g235, _g236, _g237, _g238, _g239, _g240, _g241, _g242, _g243, _g244, _g245, _g246, _g247, _g248, _g249, _g250, _g251, _g252, _g253, _g254, _path8, _path9, _path10, _g255, _g256, _g257, _g258, _g259, _g260, _g261, _path11, _g262, _path12, _g263, _g264, _path13, _path14, _path15, _path16, _path17, _g265, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g266, _g267, _g268, _path27, _g269, _g270, _g271, _g272, _g273, _g274, _g275, _g276, _g277, _g278, _g279, _g280, _g281, _g282, _g283, _g284, _g285, _g286, _g287, _g288, _g289, _g290, _g291, _g292, _g293, _g294, _path28, _g295;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1681,
    height: 271,
    viewBox: "0 0 1681 271",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_881",
    x: 0,
    y: 0,
    width: 1681,
    height: 271,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#f8e1f7",
    floodOpacity: 0.498
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_124",
    x: 124.501,
    y: 214.5,
    width: 43,
    height: 43,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_127",
    x: 31.501,
    y: 33.5,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b58ab7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7d082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4eff7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#481047"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -0.22,
    y1: 0.609,
    x2: 0.98,
    y2: 0.818,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 0,
    y1: -0.152,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 0.976,
    y1: 0.863,
    x2: -0.104,
    y2: 0.274,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 1.181,
    y1: 1.573,
    x2: -0.061,
    y2: -0.162,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 1.062,
    y1: 1.367,
    x2: -0.121,
    y2: -0.073,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#210321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: -0.013,
    y1: -0.351,
    x2: 0.798,
    y2: 1.181,
    xlinkHref: "#linear-gradient-49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -0.084,
    y1: 0.01,
    x2: 1.147,
    y2: 1.256,
    xlinkHref: "#linear-gradient-49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 1.016,
    y1: 0.036,
    x2: 0.128,
    y2: 0.773,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.268,
    stopColor: "#f4eef3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    stopColor: "#d8c3d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccb1cb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 0,
    y1: -0.183,
    x2: 0.696,
    y2: 0.972,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.709,
    gradientTransform: "translate(0.213) scale(0.575 1)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.295,
    cy: 0.328,
    r: 0.298,
    gradientTransform: "translate(-0.716) scale(2.433 1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 0.027,
    y1: -0.082,
    x2: 1.208,
    y2: 1.141,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#481047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4eff7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 0.364,
    cy: 0.503,
    r: 0.457,
    gradientTransform: "translate(-0.112) scale(1.224 1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 0.204,
    y1: -0.092,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 0.976,
    y1: 1.27,
    x2: 0,
    y2: -0.314,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 0.353,
    cy: 0.659,
    r: 0.381,
    gradientTransform: "translate(-0.521 38.931) scale(2.475 1.662)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.136,
    stopColor: "#25166d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.217,
    stopColor: "#2b1d71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#3e317e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#5d5192"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#877faf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#beb9d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 2.394,
    y1: 0.748,
    x2: -1.507,
    y2: 0.237,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.581,
    stopColor: "#d4d1d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eeebf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    xlinkHref: "#linear-gradient-55"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 0.905,
    y1: -0.182,
    x2: -0.275,
    y2: 1.535,
    xlinkHref: "#linear-gradient-55"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 1.045,
    y1: -0.375,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: -71.79,
    y1: -141.782,
    x2: -63.316,
    y2: -146.395,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbb516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c1dc9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Banner",
    transform: "translate(10.515 9.5)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -10.51, -9.5)",
    filter: "url(#Rectangle_881)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_881-2",
    "data-name": "Rectangle 881",
    width: 1660,
    height: 250,
    rx: 15,
    transform: "translate(10.5 9.5)",
    fill: "#481047"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -10.51, -9.5)",
    filter: "url(#Ellipse_124)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_124-2",
    "data-name": "Ellipse 124",
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    transform: "translate(133.5 220.5)",
    fill: "#d9d0e4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -10.51, -9.5)",
    filter: "url(#Ellipse_127)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_127-2",
    "data-name": "Ellipse 127",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(40.5 39.5)",
    fill: "#f7d38b"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Plus",
    transform: "translate(-350.666 -213.835)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plus1",
    transform: "translate(657.706 312.006) rotate(34)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_329",
    "data-name": "Rectangle 329",
    width: 20.558,
    height: 3.084,
    rx: 1.542,
    transform: "translate(0 8.778)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_330",
    "data-name": "Rectangle 330",
    width: 20.558,
    height: 3.084,
    rx: 1.542,
    transform: "translate(11.338 -0.559) rotate(90)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus1-2",
    "data-name": "Plus1",
    transform: "translate(678.263 291.449) rotate(34)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_329-2",
    "data-name": "Rectangle 329",
    width: 20.558,
    height: 3.084,
    rx: 1.542,
    transform: "translate(0 8.778)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_330-2",
    "data-name": "Rectangle 330",
    width: 20.558,
    height: 3.084,
    rx: 1.542,
    transform: "translate(11.338 -0.559) rotate(90)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus1-3",
    "data-name": "Plus1",
    transform: "translate(698.821 268.835) rotate(34)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_329-3",
    "data-name": "Rectangle 329",
    width: 20.558,
    height: 3.084,
    rx: 1.542,
    transform: "translate(0 8.778)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_330-3",
    "data-name": "Rectangle 330",
    width: 20.558,
    height: 3.084,
    rx: 1.542,
    transform: "translate(11.338 -0.559) rotate(90)",
    fill: "url(#linear-gradient)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Plus-2",
    "data-name": "Plus",
    transform: "translate(615.468 -258.863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plus1-4",
    "data-name": "Plus1",
    transform: "translate(655.137 300.723) rotate(34)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_329-4",
    "data-name": "Rectangle 329",
    width: 15.405,
    height: 2.311,
    rx: 1.155,
    transform: "translate(0 6.997)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_330-4",
    "data-name": "Rectangle 330",
    width: 15.405,
    height: 2.311,
    rx: 1.155,
    transform: "translate(8.496 0) rotate(90)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus1-5",
    "data-name": "Plus1",
    transform: "translate(670.543 285.317) rotate(34)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_329-5",
    "data-name": "Rectangle 329",
    width: 15.405,
    height: 2.311,
    rx: 1.155,
    transform: "translate(0 6.997)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_330-5",
    "data-name": "Rectangle 330",
    width: 15.405,
    height: 2.311,
    rx: 1.155,
    transform: "translate(8.496 0) rotate(90)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus1-6",
    "data-name": "Plus1",
    transform: "translate(685.948 268.372) rotate(34)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_329-6",
    "data-name": "Rectangle 329",
    width: 15.405,
    height: 2.311,
    rx: 1.155,
    transform: "translate(0 6.997)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_330-6",
    "data-name": "Rectangle 330",
    width: 15.405,
    height: 2.311,
    rx: 1.155,
    transform: "translate(8.496 0) rotate(90)",
    fill: "url(#linear-gradient)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "dot_group",
    "data-name": "dot group",
    transform: "translate(1204.053 -153.78)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse1_",
    "data-name": "Ellipse1 ",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(398.934 331.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse2",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(410.934 331.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 1,
    cy: 1.5,
    rx: 1,
    ry: 1.5,
    transform: "translate(423.934 331.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse4",
    cx: 1,
    cy: 1.5,
    rx: 1,
    ry: 1.5,
    transform: "translate(399.934 343.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse5",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(410.934 343.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse6",
    cx: 1,
    cy: 1.5,
    rx: 1,
    ry: 1.5,
    transform: "translate(423.934 343.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse7",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(399.934 356.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse8",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(410.934 356.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse9",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(423.934 356.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse10",
    cx: 2,
    cy: 1.5,
    rx: 2,
    ry: 1.5,
    transform: "translate(399.934 368.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse11",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(411.934 368.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse12",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(423.934 368.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse13",
    cx: 2,
    cy: 1.5,
    rx: 2,
    ry: 1.5,
    transform: "translate(399.934 380.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse14",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(411.934 380.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse15",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(423.934 380.78)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3845",
    "data-name": "Group 3845",
    transform: "translate(354.529 -202.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3477",
    "data-name": "Group 3477",
    transform: "translate(1033.207 335.415)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3476",
    "data-name": "Group 3476",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10650",
    "data-name": "Path 10650",
    d: "M120.885,223c-.045-.078-.1-2-.1-2l.111-.122.057.409Z",
    transform: "translate(-106.863 -216.515)",
    fill: "url(#linear-gradient-13)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3450",
    "data-name": "Group 3450",
    transform: "translate(11.568)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10651",
    "data-name": "Path 10651",
    d: "M117.682,215.975l.005,1.916.035-.849-.005-1.916Z",
    transform: "translate(-117.682 -215.126)",
    fill: "url(#linear-gradient-13)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3451",
    "data-name": "Group 3451",
    transform: "translate(16.792 2.366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10652",
    "data-name": "Path 10652",
    d: "M124.569,218.843l.005,1.916,1.036-.6-.005-1.916Z",
    transform: "translate(-124.569 -218.245)",
    fill: "url(#linear-gradient-13)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3452",
    "data-name": "Group 3452",
    transform: "translate(1.565 2.444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10653",
    "data-name": "Path 10653",
    d: "M104.5,218.347l.005,1.916,1.044.589-.005-1.916Z",
    transform: "translate(-104.495 -218.347)",
    fill: "url(#linear-gradient-13)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3453",
    "data-name": "Group 3453",
    transform: "translate(7.98 2.879)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10654",
    "data-name": "Path 10654",
    d: "M112.952,219.118l.005,1.917a7.942,7.942,0,0,1,3.441-.017l-.005-1.916A7.954,7.954,0,0,0,112.952,219.118Z",
    transform: "translate(-112.952 -218.922)",
    fill: "url(#linear-gradient-13)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3454",
    "data-name": "Group 3454",
    transform: "translate(11.421 3.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10655",
    "data-name": "Path 10655",
    d: "M117.488,219.159l.005,1.916.12.035-.005-1.916Z",
    transform: "translate(-117.488 -219.159)",
    fill: "url(#linear-gradient-13)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3455",
    "data-name": "Group 3455",
    transform: "translate(7.845 3.076)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10656",
    "data-name": "Path 10656",
    d: "M112.774,219.225l.005,1.916.135-.043-.005-1.916Z",
    transform: "translate(-112.774 -219.181)",
    fill: "url(#linear-gradient-13)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3456",
    "data-name": "Group 3456",
    transform: "translate(11.541 3.094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10657",
    "data-name": "Path 10657",
    d: "M117.646,219.2l.005,1.917a5.633,5.633,0,0,1,1.448.545l-.005-1.916A5.618,5.618,0,0,0,117.646,219.2Z",
    transform: "translate(-117.646 -219.204)",
    fill: "url(#linear-gradient-13)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3457",
    "data-name": "Group 3457",
    transform: "translate(12.989 3.64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10658",
    "data-name": "Path 10658",
    d: "M119.555,219.924l.005,1.916a3.273,3.273,0,0,1,.982.85l-.005-1.916A3.252,3.252,0,0,0,119.555,219.924Z",
    transform: "translate(-119.555 -219.924)",
    fill: "url(#linear-gradient-13)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3458",
    "data-name": "Group 3458",
    transform: "translate(5.398 3.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10659",
    "data-name": "Path 10659",
    d: "M109.548,220.651l.006,1.916a2.989,2.989,0,0,1,.992-.85,5.213,5.213,0,0,1,1.454-.563L112,219.238a5.219,5.219,0,0,0-1.455.564A2.986,2.986,0,0,0,109.548,220.651Z",
    transform: "translate(-109.548 -219.238)",
    fill: "url(#linear-gradient-13)"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3459",
    "data-name": "Group 3459",
    transform: "translate(5.151 4.155)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10660",
    "data-name": "Path 10660",
    d: "M109.222,221.058l.177,1.917a20.369,20.369,0,0,0,.289-2.372Z",
    transform: "translate(-109.222 -220.603)",
    fill: "url(#linear-gradient-13)"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3460",
    "data-name": "Group 3460",
    transform: "translate(14.016 4.555)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10661",
    "data-name": "Path 10661",
    d: "M121.233,224l-.006-1.916a1.653,1.653,0,0,0-.318-.957l.005,1.929A1.619,1.619,0,0,1,121.233,224Z",
    transform: "translate(-120.909 -221.13)",
    fill: "url(#linear-gradient-13)"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3461",
    "data-name": "Group 3461",
    transform: "translate(4.973 4.61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10662",
    "data-name": "Path 10662",
    d: "M108.988,222.209l.005,1.916a1.672,1.672,0,0,1,.35-1.005l-.005-1.917A1.674,1.674,0,0,0,108.988,222.209Z",
    transform: "translate(-108.988 -221.203)",
    fill: "url(#linear-gradient-13)"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3462",
    "data-name": "Group 3462",
    transform: "translate(19.27 4.454)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10663",
    "data-name": "Path 10663",
    d: "M127.836,223.138l.005,1.916.027-2.14L127.863,221Z",
    transform: "translate(-127.836 -220.998)",
    fill: "url(#linear-gradient-13)"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3463",
    "data-name": "Group 3463",
    transform: "translate(17.819 6.595)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10664",
    "data-name": "Path 10664",
    d: "M125.923,223.828l.005,1.916,1.451-.009-.005-1.916Z",
    transform: "translate(-125.923 -223.82)",
    fill: "url(#linear-gradient-13)"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3464",
    "data-name": "Group 3464",
    transform: "translate(0 6.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10665",
    "data-name": "Path 10665",
    d: "M102.432,223.954l.005,1.916,1.451-.009-.005-1.916Z",
    transform: "translate(-102.432 -223.945)",
    fill: "url(#linear-gradient-13)"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3465",
    "data-name": "Group 3465",
    transform: "translate(16.719 6.603)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10666",
    "data-name": "Path 10666",
    d: "M124.472,225.347l.005,1.917a4.455,4.455,0,0,0,1.1-1.517l-.005-1.916A4.452,4.452,0,0,1,124.472,225.347Z",
    transform: "translate(-124.472 -223.831)",
    fill: "url(#linear-gradient-13)"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3466",
    "data-name": "Group 3466",
    transform: "translate(1.451 6.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10667",
    "data-name": "Path 10667",
    d: "M104.345,223.945l.005,1.917a4.193,4.193,0,0,0,1.069,1.507l-.005-1.916A4.186,4.186,0,0,1,104.345,223.945Z",
    transform: "translate(-104.345 -223.945)",
    fill: "url(#linear-gradient-13)"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3467",
    "data-name": "Group 3467",
    transform: "translate(15.091 8.718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10668",
    "data-name": "Path 10668",
    d: "M122.326,228.153l.005,1.916,2.657-1.534-.005-1.916Z",
    transform: "translate(-122.326 -226.619)",
    fill: "url(#linear-gradient-13)"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3468",
    "data-name": "Group 3468",
    transform: "translate(14.062 9.654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10669",
    "data-name": "Path 10669",
    d: "M120.97,227.853l.005,1.916,1.029.6L122,228.45Z",
    transform: "translate(-120.97 -227.853)",
    fill: "url(#linear-gradient-13)"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3469",
    "data-name": "Group 3469",
    transform: "translate(4.079 9.706)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10670",
    "data-name": "Path 10670",
    d: "M107.809,228.519l.005,1.916,1.036-.6-.005-1.916Z",
    transform: "translate(-107.809 -227.921)",
    fill: "url(#linear-gradient-13)"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3470",
    "data-name": "Group 3470",
    transform: "translate(1.469 8.805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10671",
    "data-name": "Path 10671",
    d: "M104.369,226.733l.005,1.916,2.61,1.5-.005-1.916Z",
    transform: "translate(-104.369 -226.733)",
    fill: "url(#linear-gradient-13)"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3471",
    "data-name": "Group 3471",
    transform: "translate(11.44 9.654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10672",
    "data-name": "Path 10672",
    d: "M117.513,228.485l.006,1.917a12.084,12.084,0,0,0,2.622-.633l-.005-1.917A12.081,12.081,0,0,1,117.513,228.485Z",
    transform: "translate(-117.513 -227.852)",
    fill: "url(#linear-gradient-13)"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3472",
    "data-name": "Group 3472",
    transform: "translate(5.115 9.706)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10673",
    "data-name": "Path 10673",
    d: "M109.175,227.921l.005,1.916a12.741,12.741,0,0,0,2.615.6l-.005-1.917A12.678,12.678,0,0,1,109.175,227.921Z",
    transform: "translate(-109.175 -227.921)",
    fill: "url(#linear-gradient-13)"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3473",
    "data-name": "Group 3473",
    transform: "translate(11.42 10.287)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10674",
    "data-name": "Path 10674",
    d: "M117.487,229.527l.005,1.916.02-.841-.005-1.916Z",
    transform: "translate(-117.487 -228.686)",
    fill: "url(#linear-gradient-13)"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3474",
    "data-name": "Group 3474",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10675",
    "data-name": "Path 10675",
    d: "M103.883,221.816l-1.451.009.027-2.141,1.466-.017a4.251,4.251,0,0,1,1.115-1.508L104,217.569l2.657-1.534,1.029.6a12.884,12.884,0,0,1,2.622-.649l0-.832,3.726-.026-.035.849a12.023,12.023,0,0,1,2.615.615l1.051-.606,2.595,1.508-1.036.6a4.124,4.124,0,0,1,1.054,1.5l1.451-.008-.027,2.141-1.451.008a4.452,4.452,0,0,1-1.1,1.516l1.029.6-2.656,1.534-1.029-.6a12.081,12.081,0,0,1-2.622.633l-.02.841-3.71.017.02-.84a12.679,12.679,0,0,1-2.615-.6l-1.036.6-2.609-1.5,1.051-.607A4.185,4.185,0,0,1,103.883,221.816Zm6.321,1.378.134.026a7.82,7.82,0,0,0,3.442-.017l.134-.026a6.228,6.228,0,0,0,1.455-.58,3.533,3.533,0,0,0,1.052-.919,1.7,1.7,0,0,0-.018-2.062,3.252,3.252,0,0,0-.982-.85,5.618,5.618,0,0,0-1.448-.546l-.12-.034a7.953,7.953,0,0,0-3.441.017l-.135.043a5.219,5.219,0,0,0-1.455.564,3.338,3.338,0,0,0-1.067.927,1.683,1.683,0,0,0,.018,2.063,3.149,3.149,0,0,0,.968.824,5.778,5.778,0,0,0,1.463.572Z",
    transform: "translate(-102.432 -215.126)",
    fill: "url(#linear-gradient-13)"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3475",
    "data-name": "Group 3475",
    transform: "translate(7.71 11.127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10676",
    "data-name": "Path 10676",
    d: "M112.6,229.812l.005,1.916,3.71-.017-.005-1.916Z",
    transform: "translate(-112.596 -229.795)",
    fill: "url(#linear-gradient-13)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3782",
    "data-name": "Group 3782",
    transform: "translate(1031.018 231.636)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3779",
    "data-name": "Group 3779"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10678",
    "data-name": "Path 10678",
    d: "M279.629,270.735a1,1,0,0,1,.587.822.988.988,0,0,1-.578.822l-75.954,44.17a3.15,3.15,0,0,1-2.837,0L98.06,257.206a.868.868,0,0,1-.009-1.644l75.954-44.17a3.124,3.124,0,0,1,2.837,0Z",
    transform: "translate(-96.778 -116.578)",
    fill: "#3f72df",
    opacity: 0.1,
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10679",
    "data-name": "Path 10679",
    d: "M275.982,266.433a1,1,0,0,1,.588.822.99.99,0,0,1-.579.821l-73.213,42.546a3.143,3.143,0,0,1-2.837,0L97.155,251.28a.868.868,0,0,1-.009-1.644l73.213-42.546a3.124,3.124,0,0,1,2.837,0Z",
    transform: "translate(-96.559 -115.539)",
    fill: "url(#linear-gradient-40)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3778",
    "data-name": "Group 3778"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3777",
    "data-name": "Group 3777"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3481",
    "data-name": "Group 3481",
    transform: "translate(74.786)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3480",
    "data-name": "Group 3480",
    style: {
      isolation: "isolate"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10680",
    "data-name": "Path 10680",
    d: "M196.1,88.339a.755.755,0,0,1,.309-.061,1.041,1.041,0,0,1,.657.185l102.774,56.511a3.4,3.4,0,0,1,1.129,1.807,4.685,4.685,0,0,1,.287,1.417L301,236.35a1.366,1.366,0,0,1-.061.431.721.721,0,0,1-.144.308.572.572,0,0,1-.206.185l3.04-1.766a1,1,0,0,0,.41-.924l.226-88.133a4.776,4.776,0,0,0-.288-1.437,3.471,3.471,0,0,0-1.129-1.807L200.079,86.7a.992.992,0,0,0-1.026-.082Z",
    transform: "translate(-195.377 -86.507)",
    fill: "#cdc4fd"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3479",
    "data-name": "Group 3479",
    transform: "translate(0 1.767)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10681",
    "data-name": "Path 10681",
    d: "M195.148,175.926a3.155,3.155,0,0,0,1.417,2.464l102.63,59.241.165.1a1.019,1.019,0,0,0,1.006.1.856.856,0,0,0,.206-.185.72.72,0,0,0,.144-.308,1.365,1.365,0,0,0,.061-.431l.247-88.154a4.684,4.684,0,0,0-.287-1.417,3.4,3.4,0,0,0-1.129-1.807L196.832,89.025a1.041,1.041,0,0,0-.657-.185.829.829,0,0,0-.309.061.973.973,0,0,0-.472.925Z",
    transform: "translate(-195.148 -88.836)",
    fill: "url(#linear-gradient-41)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3478",
    "data-name": "Group 3478",
    transform: "translate(1.673 0.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10682",
    "data-name": "Path 10682",
    d: "M300.14,148.421c-17.055-10.022-34.205-19.879-51.3-29.825-17.162-9.836-34.274-19.76-51.481-29.519,17.055,10.023,34.205,19.88,51.3,29.825C265.822,128.738,282.933,138.661,300.14,148.421Z",
    transform: "translate(-197.354 -89.077)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10683",
    "data-name": "Path 10683",
    d: "M299.1,152.166c-.03.026-.069-2.867-.1-2.9L199.117,94.446l-.229,77.182c0-.019,99.98,57.719,99.98,57.719Z",
    transform: "translate(-196.051 -90.19)",
    fill: "#291e40"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3484",
    "data-name": "Group 3484",
    transform: "translate(0 99.719)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3483",
    "data-name": "Group 3483",
    style: {
      isolation: "isolate"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10684",
    "data-name": "Path 10684",
    d: "M96.558,264.365v3.491a.959.959,0,0,0,.6.821l102.774,59.345a3.22,3.22,0,0,0,2.834,0l73.225-42.547a1.013,1.013,0,0,0,.575-.8v-3.511a.971.971,0,0,1-.575.821l-73.2,42.547a3.221,3.221,0,0,1-2.834,0L97.153,265.186A1.026,1.026,0,0,1,96.558,264.365Z",
    transform: "translate(-96.558 -229.17)",
    fill: "#dad3fd"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3482",
    "data-name": "Group 3482",
    transform: "translate(31.04)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10685",
    "data-name": "Path 10685",
    d: "M271.81,270.795l-91.5-52.828-42.829,25.139,91.5,52.829Z",
    transform: "translate(-137.478 -217.967)",
    fill: "url(#linear-gradient-42)"
  }))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10686",
    "data-name": "Path 10686",
    d: "M169.09,276.517v.58l17.068,9.779,16.558,9.5.509-.3L186.157,286.3Z",
    transform: "translate(-114.071 -132.384)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10687",
    "data-name": "Path 10687",
    d: "M148.53,286.368l1.359.779,15.214,8.718,17.068,9.779,8.038-4.7,7.543-4.387-16.558-9.5-17.068-9.779-8.053,4.684Z",
    transform: "translate(-109.106 -132.569)",
    fill: "#e4eff7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10688",
    "data-name": "Path 10688",
    d: "M147.877,285.9l.5.283,7.543-4.4,8.053-4.684v-.58l-8.053,4.684Z",
    transform: "translate(-108.949 -132.384)",
    fill: "#886cc3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3775",
    "data-name": "Group 3775",
    transform: "translate(36.09 101.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3488",
    "data-name": "Group 3488",
    transform: "translate(35.555)",
    style: {
      isolation: "isolate"
    }
  }, _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3485",
    "data-name": "Group 3485",
    transform: "translate(0 1.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10689",
    "data-name": "Path 10689",
    d: "M191.008,222.669l0,.516,4.686,2.723,0-.517Z",
    transform: "translate(-191.008 -222.669)",
    fill: "#e4eff7"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3486",
    "data-name": "Group 3486",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10690",
    "data-name": "Path 10690",
    d: "M197.186,225.649l0,.517,3.316-1.915,0-.516Z",
    transform: "translate(-197.186 -223.735)",
    fill: "#e4eff7"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3487",
    "data-name": "Group 3487"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10691",
    "data-name": "Path 10691",
    d: "M191.008,222.059l4.686,2.723,3.316-1.915-4.686-2.723Z",
    transform: "translate(-191.008 -220.145)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3492",
    "data-name": "Group 3492",
    transform: "translate(41.902 3.688)",
    style: {
      isolation: "isolate"
    }
  }, _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3489",
    "data-name": "Group 3489",
    transform: "translate(0 1.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10692",
    "data-name": "Path 10692",
    d: "M199.375,227.531l0,.517,4.686,2.723,0-.516Z",
    transform: "translate(-199.375 -227.531)",
    fill: "#e4eff7"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3490",
    "data-name": "Group 3490",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10693",
    "data-name": "Path 10693",
    d: "M205.553,230.512l0,.516,3.316-1.915,0-.516Z",
    transform: "translate(-205.553 -228.597)",
    fill: "#e4eff7"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3491",
    "data-name": "Group 3491"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10694",
    "data-name": "Path 10694",
    d: "M199.375,226.922l4.686,2.723,3.316-1.915-4.686-2.723Z",
    transform: "translate(-199.375 -225.007)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3496",
    "data-name": "Group 3496",
    transform: "translate(28.444 2.76)",
    style: {
      isolation: "isolate"
    }
  }, _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3493",
    "data-name": "Group 3493",
    transform: "translate(0 3.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10695",
    "data-name": "Path 10695",
    d: "M181.634,228.081l0,.516,11.033,6.412,0-.516Z",
    transform: "translate(-181.634 -228.081)",
    fill: "#e4eff7"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3494",
    "data-name": "Group 3494",
    transform: "translate(11.033 6.412)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10696",
    "data-name": "Path 10696",
    d: "M196.178,235.5l0,.516,5.647-3.26,0-.517Z",
    transform: "translate(-196.178 -232.235)",
    fill: "#e4eff7"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3495",
    "data-name": "Group 3495"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10697",
    "data-name": "Path 10697",
    d: "M181.634,227.043l11.033,6.411,5.647-3.26-11.033-6.412Z",
    transform: "translate(-181.634 -223.783)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3506",
    "data-name": "Group 3506",
    transform: "translate(14.222 6.87)",
    style: {
      isolation: "isolate"
    }
  }, _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3497",
    "data-name": "Group 3497",
    transform: "translate(12.479 3.975)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10698",
    "data-name": "Path 10698",
    d: "M179.336,238.548l0,.516,7.111-4.106,0-.516Z",
    transform: "translate(-179.336 -234.443)",
    fill: "#e4eff7"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3498",
    "data-name": "Group 3498",
    transform: "translate(15.496 4.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10699",
    "data-name": "Path 10699",
    d: "M183.313,238.881,188,241.6l5.638-3.255-4.686-2.723Z",
    transform: "translate(-183.313 -235.626)",
    fill: "#e4eff7"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3499",
    "data-name": "Group 3499",
    transform: "translate(15.496 8.128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10700",
    "data-name": "Path 10700",
    d: "M183.313,239.917l0,.516L188,243.157l0-.516Z",
    transform: "translate(-183.313 -239.917)",
    fill: "#e4eff7"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3500",
    "data-name": "Group 3500",
    transform: "translate(20.182 7.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10701",
    "data-name": "Path 10701",
    d: "M189.49,242.471l0,.517,5.638-3.255,0-.516Z",
    transform: "translate(-189.49 -239.216)",
    fill: "#e4eff7"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3501",
    "data-name": "Group 3501",
    transform: "translate(0 7.361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10702",
    "data-name": "Path 10702",
    d: "M162.885,238.906l0,.516,6.347,3.688,0-.517Z",
    transform: "translate(-162.885 -238.906)",
    fill: "#e4eff7"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3502",
    "data-name": "Group 3502",
    transform: "translate(6.347 11.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10703",
    "data-name": "Path 10703",
    d: "M171.252,243.768l0,.517,1.382.8,0-.517Z",
    transform: "translate(-171.252 -243.768)",
    fill: "#e4eff7"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3503",
    "data-name": "Group 3503",
    transform: "translate(11.033 10.517)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10704",
    "data-name": "Path 10704",
    d: "M177.429,246.322l0,.516,5.638-3.255,0-.516Z",
    transform: "translate(-177.429 -243.067)",
    fill: "#e4eff7"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3504",
    "data-name": "Group 3504",
    transform: "translate(7.729 11.853)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10705",
    "data-name": "Path 10705",
    d: "M173.074,244.827l0,.516,3.3,1.92,0-.516Z",
    transform: "translate(-173.074 -244.827)",
    fill: "#e4eff7"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3505",
    "data-name": "Group 3505"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10706",
    "data-name": "Path 10706",
    d: "M162.885,236.563l6.347,3.688,1.382.8,3.3,1.92,5.638-3.255-4.192-2.436,7.111-4.106-6.84-3.975Z",
    transform: "translate(-162.885 -229.202)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3510",
    "data-name": "Group 3510",
    transform: "translate(7.111 15.082)",
    style: {
      isolation: "isolate"
    }
  }, _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3507",
    "data-name": "Group 3507",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10707",
    "data-name": "Path 10707",
    d: "M153.51,244.318l0,.516,13.07,7.6,0-.516Z",
    transform: "translate(-153.51 -244.318)",
    fill: "#e4eff7"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3508",
    "data-name": "Group 3508",
    transform: "translate(13.07 7.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10708",
    "data-name": "Path 10708",
    d: "M170.741,253.3l0,.516,5.638-3.255,0-.516Z",
    transform: "translate(-170.741 -250.04)",
    fill: "#e4eff7"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3509",
    "data-name": "Group 3509"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10709",
    "data-name": "Path 10709",
    d: "M153.51,243.282l13.07,7.6,5.638-3.255-13.071-7.6Z",
    transform: "translate(-153.51 -240.027)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3514",
    "data-name": "Group 3514",
    transform: "translate(48.249 7.377)",
    style: {
      isolation: "isolate"
    }
  }, _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3511",
    "data-name": "Group 3511",
    transform: "translate(0 1.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10710",
    "data-name": "Path 10710",
    d: "M207.742,232.393l0,.516,4.695,2.728,0-.517Z",
    transform: "translate(-207.742 -232.393)",
    fill: "#e4eff7"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3512",
    "data-name": "Group 3512",
    transform: "translate(4.695 2.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10711",
    "data-name": "Path 10711",
    d: "M213.932,235.381l0,.517,3.316-1.915,0-.516Z",
    transform: "translate(-213.932 -233.466)",
    fill: "#e4eff7"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3513",
    "data-name": "Group 3513"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10712",
    "data-name": "Path 10712",
    d: "M207.742,231.784l4.695,2.728,3.316-1.914-4.695-2.728Z",
    transform: "translate(-207.742 -229.869)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3518",
    "data-name": "Group 3518",
    transform: "translate(54.605 11.07)",
    style: {
      isolation: "isolate"
    }
  }, _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3515",
    "data-name": "Group 3515",
    transform: "translate(0 1.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10713",
    "data-name": "Path 10713",
    d: "M216.121,237.262l0,.517,4.686,2.723,0-.517Z",
    transform: "translate(-216.121 -237.262)",
    fill: "#e4eff7"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3516",
    "data-name": "Group 3516",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10714",
    "data-name": "Path 10714",
    d: "M222.3,240.243l0,.517,3.316-1.915,0-.516Z",
    transform: "translate(-222.299 -238.329)",
    fill: "#e4eff7"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3517",
    "data-name": "Group 3517"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10715",
    "data-name": "Path 10715",
    d: "M216.121,236.653l4.686,2.723,3.316-1.915-4.686-2.723Z",
    transform: "translate(-216.121 -234.739)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3522",
    "data-name": "Group 3522",
    transform: "translate(60.951 14.758)",
    style: {
      isolation: "isolate"
    }
  }, _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3519",
    "data-name": "Group 3519",
    transform: "translate(0 1.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10716",
    "data-name": "Path 10716",
    d: "M224.488,242.125l0,.516,4.686,2.723,0-.516Z",
    transform: "translate(-224.488 -242.125)",
    fill: "#e4eff7"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3520",
    "data-name": "Group 3520",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10717",
    "data-name": "Path 10717",
    d: "M230.666,245.106l0,.516,3.316-1.915,0-.517Z",
    transform: "translate(-230.666 -243.191)",
    fill: "#e4eff7"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3521",
    "data-name": "Group 3521"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10718",
    "data-name": "Path 10718",
    d: "M224.488,241.515l4.686,2.723,3.316-1.915L227.8,239.6Z",
    transform: "translate(-224.488 -239.601)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3526",
    "data-name": "Group 3526",
    transform: "translate(67.298 18.447)",
    style: {
      isolation: "isolate"
    }
  }, _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3523",
    "data-name": "Group 3523",
    transform: "translate(0 1.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10719",
    "data-name": "Path 10719",
    d: "M232.855,246.987l0,.516,4.695,2.728,0-.516Z",
    transform: "translate(-232.855 -246.987)",
    fill: "#e4eff7"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3524",
    "data-name": "Group 3524",
    transform: "translate(4.695 2.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10720",
    "data-name": "Path 10720",
    d: "M239.044,249.975l0,.517,3.316-1.915,0-.516Z",
    transform: "translate(-239.044 -248.06)",
    fill: "#e4eff7"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3525",
    "data-name": "Group 3525"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10721",
    "data-name": "Path 10721",
    d: "M232.855,246.378l4.695,2.728,3.316-1.914-4.695-2.728Z",
    transform: "translate(-232.855 -244.463)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3530",
    "data-name": "Group 3530",
    transform: "translate(73.654 22.14)",
    style: {
      isolation: "isolate"
    }
  }, _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3527",
    "data-name": "Group 3527",
    transform: "translate(0 1.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10722",
    "data-name": "Path 10722",
    d: "M241.234,251.856l0,.516,4.686,2.723,0-.516Z",
    transform: "translate(-241.234 -251.856)",
    fill: "#e4eff7"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3528",
    "data-name": "Group 3528",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10723",
    "data-name": "Path 10723",
    d: "M247.411,254.837l0,.516,3.316-1.914,0-.517Z",
    transform: "translate(-247.411 -252.922)",
    fill: "#e4eff7"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3529",
    "data-name": "Group 3529"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10724",
    "data-name": "Path 10724",
    d: "M241.234,251.247l4.686,2.723,3.316-1.915-4.686-2.723Z",
    transform: "translate(-241.234 -249.332)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3534",
    "data-name": "Group 3534",
    transform: "translate(80.001 25.829)",
    style: {
      isolation: "isolate"
    }
  }, _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3531",
    "data-name": "Group 3531",
    transform: "translate(0 1.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10725",
    "data-name": "Path 10725",
    d: "M249.6,256.719l0,.516,4.686,2.723,0-.516Z",
    transform: "translate(-249.601 -256.719)",
    fill: "#e4eff7"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3532",
    "data-name": "Group 3532",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10726",
    "data-name": "Path 10726",
    d: "M255.778,259.7l0,.516L259.1,258.3l0-.517Z",
    transform: "translate(-255.778 -257.785)",
    fill: "#e4eff7"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3533",
    "data-name": "Group 3533"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10727",
    "data-name": "Path 10727",
    d: "M249.6,256.109l4.686,2.723,3.316-1.915-4.686-2.723Z",
    transform: "translate(-249.601 -254.195)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3538",
    "data-name": "Group 3538",
    transform: "translate(86.347 29.517)",
    style: {
      isolation: "isolate"
    }
  }, _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3535",
    "data-name": "Group 3535",
    transform: "translate(0 1.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10728",
    "data-name": "Path 10728",
    d: "M257.967,261.581l0,.517,4.695,2.728,0-.516Z",
    transform: "translate(-257.967 -261.581)",
    fill: "#e4eff7"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3536",
    "data-name": "Group 3536",
    transform: "translate(4.695 2.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10729",
    "data-name": "Path 10729",
    d: "M264.157,264.568l0,.516,3.316-1.915,0-.516Z",
    transform: "translate(-264.157 -262.654)",
    fill: "#e4eff7"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3537",
    "data-name": "Group 3537"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10730",
    "data-name": "Path 10730",
    d: "M257.967,260.972l4.695,2.728,3.316-1.914-4.695-2.728Z",
    transform: "translate(-257.967 -259.057)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3542",
    "data-name": "Group 3542",
    transform: "translate(92.703 33.211)",
    style: {
      isolation: "isolate"
    }
  }, _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3539",
    "data-name": "Group 3539",
    transform: "translate(0 1.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10731",
    "data-name": "Path 10731",
    d: "M266.346,266.45l0,.516,4.686,2.723,0-.516Z",
    transform: "translate(-266.346 -266.45)",
    fill: "#e4eff7"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3540",
    "data-name": "Group 3540",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10732",
    "data-name": "Path 10732",
    d: "M272.524,269.431l0,.516,3.316-1.915,0-.516Z",
    transform: "translate(-272.524 -267.516)",
    fill: "#e4eff7"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3541",
    "data-name": "Group 3541"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10733",
    "data-name": "Path 10733",
    d: "M266.346,265.841l4.686,2.723,3.316-1.915-4.686-2.723Z",
    transform: "translate(-266.346 -263.926)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3546",
    "data-name": "Group 3546",
    transform: "translate(99.05 36.899)",
    style: {
      isolation: "isolate"
    }
  }, _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3543",
    "data-name": "Group 3543",
    transform: "translate(0 1.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10734",
    "data-name": "Path 10734",
    d: "M274.713,271.313l0,.516,4.686,2.723,0-.516Z",
    transform: "translate(-274.713 -271.313)",
    fill: "#e4eff7"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3544",
    "data-name": "Group 3544",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10735",
    "data-name": "Path 10735",
    d: "M280.891,274.293l0,.517,3.316-1.915,0-.516Z",
    transform: "translate(-280.891 -272.379)",
    fill: "#e4eff7"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3545",
    "data-name": "Group 3545"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10736",
    "data-name": "Path 10736",
    d: "M274.713,270.7l4.686,2.723,3.316-1.914-4.686-2.723Z",
    transform: "translate(-274.713 -268.789)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3550",
    "data-name": "Group 3550",
    transform: "translate(105.396 40.587)",
    style: {
      isolation: "isolate"
    }
  }, _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3547",
    "data-name": "Group 3547",
    transform: "translate(0 1.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10737",
    "data-name": "Path 10737",
    d: "M283.08,276.175l0,.517,4.7,2.728,0-.517Z",
    transform: "translate(-283.08 -276.175)",
    fill: "#e4eff7"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3548",
    "data-name": "Group 3548",
    transform: "translate(4.695 2.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10738",
    "data-name": "Path 10738",
    d: "M289.27,279.162l0,.517,3.316-1.915,0-.516Z",
    transform: "translate(-289.27 -277.248)",
    fill: "#e4eff7"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3549",
    "data-name": "Group 3549"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10739",
    "data-name": "Path 10739",
    d: "M283.08,275.565l4.695,2.728,3.316-1.915-4.695-2.728Z",
    transform: "translate(-283.08 -273.651)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3554",
    "data-name": "Group 3554",
    transform: "translate(111.743 44.275)",
    style: {
      isolation: "isolate"
    }
  }, _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3551",
    "data-name": "Group 3551",
    transform: "translate(0 1.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10740",
    "data-name": "Path 10740",
    d: "M291.447,281.037l0,.516,4.7,2.728,0-.516Z",
    transform: "translate(-291.447 -281.037)",
    fill: "#e4eff7"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3552",
    "data-name": "Group 3552",
    transform: "translate(4.695 2.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10741",
    "data-name": "Path 10741",
    d: "M297.636,284.025l0,.516,3.316-1.915,0-.516Z",
    transform: "translate(-297.636 -282.11)",
    fill: "#e4eff7"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3553",
    "data-name": "Group 3553"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10742",
    "data-name": "Path 10742",
    d: "M291.447,280.428l4.695,2.728,3.316-1.915-4.695-2.728Z",
    transform: "translate(-291.447 -278.513)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3558",
    "data-name": "Group 3558",
    transform: "translate(118.099 47.969)",
    style: {
      isolation: "isolate"
    }
  }, _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3555",
    "data-name": "Group 3555",
    transform: "translate(0 1.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10743",
    "data-name": "Path 10743",
    d: "M299.826,285.906l0,.516,4.686,2.723,0-.516Z",
    transform: "translate(-299.826 -285.906)",
    fill: "#e4eff7"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3556",
    "data-name": "Group 3556",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10744",
    "data-name": "Path 10744",
    d: "M306,288.887l0,.516,3.316-1.915,0-.516Z",
    transform: "translate(-306.003 -286.972)",
    fill: "#e4eff7"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3557",
    "data-name": "Group 3557"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10745",
    "data-name": "Path 10745",
    d: "M299.826,285.3l4.686,2.723,3.316-1.915-4.686-2.723Z",
    transform: "translate(-299.826 -283.382)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3562",
    "data-name": "Group 3562",
    transform: "translate(41.138 10.136)",
    style: {
      isolation: "isolate"
    }
  }, _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3559",
    "data-name": "Group 3559",
    transform: "translate(0 3.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10746",
    "data-name": "Path 10746",
    d: "M198.368,237.806l0,.516,4.695,2.728,0-.517Z",
    transform: "translate(-198.368 -237.806)",
    fill: "#e4eff7"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3560",
    "data-name": "Group 3560",
    transform: "translate(4.695 2.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10747",
    "data-name": "Path 10747",
    d: "M204.557,240.365l0,.516,5.647-3.26,0-.516Z",
    transform: "translate(-204.557 -237.104)",
    fill: "#e4eff7"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3561",
    "data-name": "Group 3561"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10748",
    "data-name": "Path 10748",
    d: "M198.368,236.768l4.695,2.728,5.647-3.26-4.695-2.728Z",
    transform: "translate(-198.368 -233.508)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3566",
    "data-name": "Group 3566",
    transform: "translate(47.494 13.83)",
    style: {
      isolation: "isolate"
    }
  }, _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3563",
    "data-name": "Group 3563",
    transform: "translate(0 3.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10749",
    "data-name": "Path 10749",
    d: "M206.747,242.675l0,.516,4.686,2.723,0-.516Z",
    transform: "translate(-206.747 -242.675)",
    fill: "#e4eff7"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3564",
    "data-name": "Group 3564",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10750",
    "data-name": "Path 10750",
    d: "M212.924,245.227l0,.516,5.647-3.26,0-.516Z",
    transform: "translate(-212.924 -241.967)",
    fill: "#e4eff7"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3565",
    "data-name": "Group 3565"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10751",
    "data-name": "Path 10751",
    d: "M206.747,241.637l4.686,2.723,5.647-3.26-4.686-2.723Z",
    transform: "translate(-206.747 -238.377)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3570",
    "data-name": "Group 3570",
    transform: "translate(53.84 17.518)",
    style: {
      isolation: "isolate"
    }
  }, _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3567",
    "data-name": "Group 3567",
    transform: "translate(0 3.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10752",
    "data-name": "Path 10752",
    d: "M215.113,247.537l0,.516,4.686,2.723,0-.516Z",
    transform: "translate(-215.113 -247.537)",
    fill: "#e4eff7"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3568",
    "data-name": "Group 3568",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10753",
    "data-name": "Path 10753",
    d: "M221.291,250.089l0,.516,5.647-3.26,0-.516Z",
    transform: "translate(-221.291 -246.829)",
    fill: "#e4eff7"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3569",
    "data-name": "Group 3569"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10754",
    "data-name": "Path 10754",
    d: "M215.113,246.5l4.686,2.723,5.647-3.26-4.686-2.723Z",
    transform: "translate(-215.113 -243.239)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3574",
    "data-name": "Group 3574",
    transform: "translate(60.187 21.206)",
    style: {
      isolation: "isolate"
    }
  }, _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3571",
    "data-name": "Group 3571",
    transform: "translate(0 3.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10755",
    "data-name": "Path 10755",
    d: "M223.48,252.4l0,.516,4.695,2.728,0-.516Z",
    transform: "translate(-223.48 -252.4)",
    fill: "#e4eff7"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3572",
    "data-name": "Group 3572",
    transform: "translate(4.695 2.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10756",
    "data-name": "Path 10756",
    d: "M229.67,254.959l0,.516,5.647-3.26,0-.516Z",
    transform: "translate(-229.67 -251.698)",
    fill: "#e4eff7"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3573",
    "data-name": "Group 3573"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10757",
    "data-name": "Path 10757",
    d: "M223.48,251.362l4.695,2.728,5.647-3.26-4.695-2.728Z",
    transform: "translate(-223.48 -248.101)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3578",
    "data-name": "Group 3578",
    transform: "translate(66.543 24.9)",
    style: {
      isolation: "isolate"
    }
  }, _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3575",
    "data-name": "Group 3575",
    transform: "translate(0 3.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10758",
    "data-name": "Path 10758",
    d: "M231.859,257.269l0,.516,4.686,2.723,0-.516Z",
    transform: "translate(-231.859 -257.269)",
    fill: "#e4eff7"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3576",
    "data-name": "Group 3576",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10759",
    "data-name": "Path 10759",
    d: "M238.037,259.821l0,.516,5.647-3.26,0-.516Z",
    transform: "translate(-238.037 -256.56)",
    fill: "#e4eff7"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3577",
    "data-name": "Group 3577"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10760",
    "data-name": "Path 10760",
    d: "M231.859,256.231l4.686,2.723,5.647-3.261-4.686-2.723Z",
    transform: "translate(-231.859 -252.971)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3582",
    "data-name": "Group 3582",
    transform: "translate(73.5 28.943)",
    style: {
      isolation: "isolate"
    }
  }, _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3579",
    "data-name": "Group 3579",
    transform: "translate(0 3.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10761",
    "data-name": "Path 10761",
    d: "M241.031,262.6l0,.516,4.695,2.728,0-.516Z",
    transform: "translate(-241.031 -262.599)",
    fill: "#e4eff7"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3580",
    "data-name": "Group 3580",
    transform: "translate(4.695 2.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10762",
    "data-name": "Path 10762",
    d: "M247.22,265.158l0,.516,5.647-3.26,0-.516Z",
    transform: "translate(-247.22 -261.897)",
    fill: "#e4eff7"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3581",
    "data-name": "Group 3581"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10763",
    "data-name": "Path 10763",
    d: "M241.031,261.561l4.695,2.728,5.647-3.26-4.695-2.728Z",
    transform: "translate(-241.031 -258.301)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3586",
    "data-name": "Group 3586",
    transform: "translate(79.856 32.637)",
    style: {
      isolation: "isolate"
    }
  }, _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3583",
    "data-name": "Group 3583",
    transform: "translate(0 3.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10764",
    "data-name": "Path 10764",
    d: "M249.41,267.468l0,.516,4.686,2.723,0-.516Z",
    transform: "translate(-249.41 -267.468)",
    fill: "#e4eff7"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3584",
    "data-name": "Group 3584",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10765",
    "data-name": "Path 10765",
    d: "M255.587,270.02l0,.516,5.647-3.26,0-.516Z",
    transform: "translate(-255.587 -266.76)",
    fill: "#e4eff7"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3585",
    "data-name": "Group 3585"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10766",
    "data-name": "Path 10766",
    d: "M249.41,266.43l4.686,2.723,5.647-3.26-4.686-2.723Z",
    transform: "translate(-249.41 -263.17)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3590",
    "data-name": "Group 3590",
    transform: "translate(86.202 36.325)",
    style: {
      isolation: "isolate"
    }
  }, _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3587",
    "data-name": "Group 3587",
    transform: "translate(0 3.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10767",
    "data-name": "Path 10767",
    d: "M257.776,272.33l0,.516,4.686,2.723,0-.516Z",
    transform: "translate(-257.776 -272.33)",
    fill: "#e4eff7"
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3588",
    "data-name": "Group 3588",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10768",
    "data-name": "Path 10768",
    d: "M263.954,274.883l0,.516,5.647-3.26,0-.516Z",
    transform: "translate(-263.954 -271.622)",
    fill: "#e4eff7"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3589",
    "data-name": "Group 3589"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10769",
    "data-name": "Path 10769",
    d: "M257.776,271.292l4.686,2.723,5.647-3.26-4.686-2.723Z",
    transform: "translate(-257.776 -268.032)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3594",
    "data-name": "Group 3594",
    transform: "translate(92.549 40.013)",
    style: {
      isolation: "isolate"
    }
  }, _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3591",
    "data-name": "Group 3591",
    transform: "translate(0 3.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10770",
    "data-name": "Path 10770",
    d: "M266.143,277.193l0,.517,4.695,2.728,0-.516Z",
    transform: "translate(-266.143 -277.193)",
    fill: "#e4eff7"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3592",
    "data-name": "Group 3592",
    transform: "translate(4.695 2.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10771",
    "data-name": "Path 10771",
    d: "M272.333,279.752l0,.516,5.647-3.26,0-.516Z",
    transform: "translate(-272.333 -276.491)",
    fill: "#e4eff7"
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3593",
    "data-name": "Group 3593"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10772",
    "data-name": "Path 10772",
    d: "M266.143,276.155l4.7,2.728,5.647-3.26-4.695-2.728Z",
    transform: "translate(-266.143 -272.894)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3598",
    "data-name": "Group 3598",
    transform: "translate(98.905 43.707)",
    style: {
      isolation: "isolate"
    }
  }, _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3595",
    "data-name": "Group 3595",
    transform: "translate(0 3.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10773",
    "data-name": "Path 10773",
    d: "M274.522,282.062l0,.517,4.686,2.723,0-.517Z",
    transform: "translate(-274.522 -282.062)",
    fill: "#e4eff7"
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3596",
    "data-name": "Group 3596",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10774",
    "data-name": "Path 10774",
    d: "M280.7,284.614l0,.517,5.647-3.26,0-.517Z",
    transform: "translate(-280.7 -281.353)",
    fill: "#e4eff7"
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3597",
    "data-name": "Group 3597"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10775",
    "data-name": "Path 10775",
    d: "M274.522,281.024l4.686,2.723,5.647-3.26-4.686-2.723Z",
    transform: "translate(-274.522 -277.763)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3602",
    "data-name": "Group 3602",
    transform: "translate(105.252 47.395)",
    style: {
      isolation: "isolate"
    }
  }, _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3599",
    "data-name": "Group 3599",
    transform: "translate(0 3.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10776",
    "data-name": "Path 10776",
    d: "M282.889,286.924l0,.517,4.686,2.723,0-.516Z",
    transform: "translate(-282.889 -286.924)",
    fill: "#e4eff7"
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3600",
    "data-name": "Group 3600",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10777",
    "data-name": "Path 10777",
    d: "M289.067,289.476l0,.517,5.647-3.26,0-.517Z",
    transform: "translate(-289.067 -286.216)",
    fill: "#e4eff7"
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3601",
    "data-name": "Group 3601"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10778",
    "data-name": "Path 10778",
    d: "M282.889,285.886l4.686,2.723,5.647-3.26-4.686-2.723Z",
    transform: "translate(-282.889 -282.626)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3606",
    "data-name": "Group 3606",
    transform: "translate(110.988 50.729)",
    style: {
      isolation: "isolate"
    }
  }, _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3603",
    "data-name": "Group 3603",
    transform: "translate(0 3.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10779",
    "data-name": "Path 10779",
    d: "M290.451,291.319l0,.516,4.686,2.723,0-.516Z",
    transform: "translate(-290.451 -291.319)",
    fill: "#e4eff7"
  }))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3604",
    "data-name": "Group 3604",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10780",
    "data-name": "Path 10780",
    d: "M296.629,293.871l0,.516,5.647-3.261,0-.516Z",
    transform: "translate(-296.629 -290.611)",
    fill: "#e4eff7"
  }))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3605",
    "data-name": "Group 3605"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10781",
    "data-name": "Path 10781",
    d: "M290.451,290.281,295.137,293l5.647-3.26L296.1,287.02Z",
    transform: "translate(-290.451 -287.02)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3610",
    "data-name": "Group 3610",
    transform: "translate(36.064 15.431)",
    style: {
      isolation: "isolate"
    }
  }, _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3607",
    "data-name": "Group 3607",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10782",
    "data-name": "Path 10782",
    d: "M191.68,244.779l0,.516,4.695,2.728,0-.516Z",
    transform: "translate(-191.68 -244.779)",
    fill: "#e4eff7"
  }))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3608",
    "data-name": "Group 3608",
    transform: "translate(4.695 2.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10783",
    "data-name": "Path 10783",
    d: "M197.869,247.34l0,.517,5.638-3.255,0-.517Z",
    transform: "translate(-197.869 -244.085)",
    fill: "#e4eff7"
  }))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3609",
    "data-name": "Group 3609"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10784",
    "data-name": "Path 10784",
    d: "M191.68,243.743l4.695,2.728,5.638-3.255-4.695-2.728Z",
    transform: "translate(-191.68 -240.488)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3614",
    "data-name": "Group 3614",
    transform: "translate(42.42 19.125)",
    style: {
      isolation: "isolate"
    }
  }, _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3611",
    "data-name": "Group 3611",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10785",
    "data-name": "Path 10785",
    d: "M200.058,249.649l0,.516,4.686,2.723,0-.516Z",
    transform: "translate(-200.058 -249.649)",
    fill: "#e4eff7"
  }))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3612",
    "data-name": "Group 3612",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10786",
    "data-name": "Path 10786",
    d: "M206.236,252.2l0,.516,5.638-3.255,0-.516Z",
    transform: "translate(-206.236 -248.947)",
    fill: "#e4eff7"
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3613",
    "data-name": "Group 3613"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10787",
    "data-name": "Path 10787",
    d: "M200.058,248.612l4.686,2.723,5.638-3.255-4.686-2.723Z",
    transform: "translate(-200.058 -245.357)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3618",
    "data-name": "Group 3618",
    transform: "translate(48.767 22.813)",
    style: {
      isolation: "isolate"
    }
  }, _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3615",
    "data-name": "Group 3615",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10788",
    "data-name": "Path 10788",
    d: "M208.425,254.511l0,.516,4.686,2.723,0-.516Z",
    transform: "translate(-208.425 -254.511)",
    fill: "#e4eff7"
  }))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3616",
    "data-name": "Group 3616",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10789",
    "data-name": "Path 10789",
    d: "M214.6,257.065l0,.516,5.638-3.255,0-.516Z",
    transform: "translate(-214.603 -253.809)",
    fill: "#e4eff7"
  }))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3617",
    "data-name": "Group 3617"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10790",
    "data-name": "Path 10790",
    d: "M208.425,253.475l4.686,2.723,5.638-3.255-4.686-2.723Z",
    transform: "translate(-208.425 -250.22)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3622",
    "data-name": "Group 3622",
    transform: "translate(55.114 26.502)",
    style: {
      isolation: "isolate"
    }
  }, _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3619",
    "data-name": "Group 3619",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10791",
    "data-name": "Path 10791",
    d: "M216.792,259.373l0,.516,4.695,2.728,0-.516Z",
    transform: "translate(-216.792 -259.373)",
    fill: "#e4eff7"
  }))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3620",
    "data-name": "Group 3620",
    transform: "translate(4.695 2.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10792",
    "data-name": "Path 10792",
    d: "M222.982,261.934l0,.516,5.638-3.255,0-.516Z",
    transform: "translate(-222.982 -258.679)",
    fill: "#e4eff7"
  }))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3621",
    "data-name": "Group 3621"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10793",
    "data-name": "Path 10793",
    d: "M216.792,258.337l4.7,2.728,5.638-3.255-4.695-2.728Z",
    transform: "translate(-216.792 -255.082)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3626",
    "data-name": "Group 3626",
    transform: "translate(62.08 30.55)",
    style: {
      isolation: "isolate"
    }
  }, _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3623",
    "data-name": "Group 3623",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10794",
    "data-name": "Path 10794",
    d: "M225.976,264.71l0,.516,4.686,2.723,0-.516Z",
    transform: "translate(-225.976 -264.71)",
    fill: "#e4eff7"
  }))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3624",
    "data-name": "Group 3624",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10795",
    "data-name": "Path 10795",
    d: "M232.153,267.264l0,.516,5.638-3.255,0-.517Z",
    transform: "translate(-232.153 -264.009)",
    fill: "#e4eff7"
  }))), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3625",
    "data-name": "Group 3625"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10796",
    "data-name": "Path 10796",
    d: "M225.976,263.674l4.686,2.723,5.638-3.255-4.686-2.723Z",
    transform: "translate(-225.976 -260.419)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3630",
    "data-name": "Group 3630",
    transform: "translate(68.427 34.238)",
    style: {
      isolation: "isolate"
    }
  }, _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3627",
    "data-name": "Group 3627",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10797",
    "data-name": "Path 10797",
    d: "M234.342,269.572l0,.516,4.7,2.728,0-.516Z",
    transform: "translate(-234.342 -269.572)",
    fill: "#e4eff7"
  }))), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3628",
    "data-name": "Group 3628",
    transform: "translate(4.695 2.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10798",
    "data-name": "Path 10798",
    d: "M240.532,272.133l0,.516,5.638-3.255,0-.516Z",
    transform: "translate(-240.532 -268.878)",
    fill: "#e4eff7"
  }))), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3629",
    "data-name": "Group 3629"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10799",
    "data-name": "Path 10799",
    d: "M234.342,268.536l4.695,2.728,5.638-3.255-4.695-2.728Z",
    transform: "translate(-234.342 -265.281)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3634",
    "data-name": "Group 3634",
    transform: "translate(74.782 37.932)",
    style: {
      isolation: "isolate"
    }
  }, _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3631",
    "data-name": "Group 3631",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10800",
    "data-name": "Path 10800",
    d: "M242.721,274.442l0,.516,4.686,2.723,0-.516Z",
    transform: "translate(-242.721 -274.442)",
    fill: "#e4eff7"
  }))), _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3632",
    "data-name": "Group 3632",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10801",
    "data-name": "Path 10801",
    d: "M248.9,277l0,.516,5.638-3.255,0-.516Z",
    transform: "translate(-248.899 -273.74)",
    fill: "#e4eff7"
  }))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3633",
    "data-name": "Group 3633"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10802",
    "data-name": "Path 10802",
    d: "M242.721,273.405l4.686,2.723,5.638-3.255-4.686-2.723Z",
    transform: "translate(-242.721 -270.15)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3638",
    "data-name": "Group 3638",
    transform: "translate(81.129 41.62)",
    style: {
      isolation: "isolate"
    }
  }, _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3635",
    "data-name": "Group 3635",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10803",
    "data-name": "Path 10803",
    d: "M251.088,279.3l0,.516,4.686,2.723,0-.516Z",
    transform: "translate(-251.088 -279.304)",
    fill: "#e4eff7"
  }))), _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3636",
    "data-name": "Group 3636",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10804",
    "data-name": "Path 10804",
    d: "M257.266,281.858l0,.516,5.638-3.255,0-.516Z",
    transform: "translate(-257.266 -278.603)",
    fill: "#e4eff7"
  }))), _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3637",
    "data-name": "Group 3637"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10805",
    "data-name": "Path 10805",
    d: "M251.088,278.268l4.686,2.723,5.638-3.255-4.686-2.723Z",
    transform: "translate(-251.088 -275.013)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3642",
    "data-name": "Group 3642",
    transform: "translate(87.476 45.308)",
    style: {
      isolation: "isolate"
    }
  }, _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3639",
    "data-name": "Group 3639",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10806",
    "data-name": "Path 10806",
    d: "M259.455,284.166l0,.516,4.7,2.728,0-.516Z",
    transform: "translate(-259.455 -284.166)",
    fill: "#e4eff7"
  }))), _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3640",
    "data-name": "Group 3640",
    transform: "translate(4.695 2.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10807",
    "data-name": "Path 10807",
    d: "M265.644,286.727l0,.516,5.638-3.255,0-.516Z",
    transform: "translate(-265.644 -283.472)",
    fill: "#e4eff7"
  }))), _g154 || (_g154 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3641",
    "data-name": "Group 3641"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10808",
    "data-name": "Path 10808",
    d: "M259.455,283.13l4.695,2.728,5.638-3.255-4.7-2.728Z",
    transform: "translate(-259.455 -279.875)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3646",
    "data-name": "Group 3646",
    transform: "translate(93.831 49.002)",
    style: {
      isolation: "isolate"
    }
  }, _g155 || (_g155 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3643",
    "data-name": "Group 3643",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10809",
    "data-name": "Path 10809",
    d: "M267.834,289.035l0,.517,4.686,2.723,0-.517Z",
    transform: "translate(-267.834 -289.035)",
    fill: "#e4eff7"
  }))), _g156 || (_g156 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3644",
    "data-name": "Group 3644",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10810",
    "data-name": "Path 10810",
    d: "M274.011,291.589l0,.517,5.638-3.255,0-.516Z",
    transform: "translate(-274.011 -288.334)",
    fill: "#e4eff7"
  }))), _g157 || (_g157 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3645",
    "data-name": "Group 3645"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10811",
    "data-name": "Path 10811",
    d: "M267.834,288l4.686,2.723,5.638-3.255-4.686-2.723Z",
    transform: "translate(-267.834 -284.744)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3650",
    "data-name": "Group 3650",
    transform: "translate(99.873 52.513)",
    style: {
      isolation: "isolate"
    }
  }, _g158 || (_g158 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3647",
    "data-name": "Group 3647",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10812",
    "data-name": "Path 10812",
    d: "M275.8,293.664l0,.516,8.69,5.05,0-.516Z",
    transform: "translate(-275.798 -293.664)",
    fill: "#e4eff7"
  }))), _g159 || (_g159 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3648",
    "data-name": "Group 3648",
    transform: "translate(8.69 5.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10813",
    "data-name": "Path 10813",
    d: "M287.254,299.285l0,.516,5.638-3.255,0-.516Z",
    transform: "translate(-287.254 -296.03)",
    fill: "#e4eff7"
  }))), _g160 || (_g160 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3649",
    "data-name": "Group 3649"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10814",
    "data-name": "Path 10814",
    d: "M275.8,292.628l8.69,5.05,5.638-3.255-8.69-5.05Z",
    transform: "translate(-275.798 -289.372)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3654",
    "data-name": "Group 3654",
    transform: "translate(26.916 18.353)",
    style: {
      isolation: "isolate"
    }
  }, _g161 || (_g161 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3651",
    "data-name": "Group 3651",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10815",
    "data-name": "Path 10815",
    d: "M179.619,248.631l0,.516,4.7,2.728,0-.516Z",
    transform: "translate(-179.619 -248.631)",
    fill: "#e4eff7"
  }))), _g162 || (_g162 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3652",
    "data-name": "Group 3652",
    transform: "translate(4.695 2.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10816",
    "data-name": "Path 10816",
    d: "M185.808,251.191l0,.517,5.638-3.255,0-.516Z",
    transform: "translate(-185.808 -247.936)",
    fill: "#e4eff7"
  }))), _g163 || (_g163 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3653",
    "data-name": "Group 3653"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10817",
    "data-name": "Path 10817",
    d: "M179.619,247.594l4.695,2.728,5.638-3.255-4.695-2.728Z",
    transform: "translate(-179.619 -244.339)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3658",
    "data-name": "Group 3658",
    transform: "translate(33.271 22.046)",
    style: {
      isolation: "isolate"
    }
  }, _g164 || (_g164 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3655",
    "data-name": "Group 3655",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10818",
    "data-name": "Path 10818",
    d: "M188,253.5l0,.517,4.686,2.723,0-.516Z",
    transform: "translate(-187.997 -253.5)",
    fill: "#e4eff7"
  }))), _g165 || (_g165 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3656",
    "data-name": "Group 3656",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10819",
    "data-name": "Path 10819",
    d: "M194.175,256.054l0,.516,5.638-3.255,0-.516Z",
    transform: "translate(-194.175 -252.798)",
    fill: "#e4eff7"
  }))), _g166 || (_g166 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3657",
    "data-name": "Group 3657"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10820",
    "data-name": "Path 10820",
    d: "M188,252.464l4.686,2.723,5.638-3.255-4.686-2.723Z",
    transform: "translate(-187.997 -249.208)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3662",
    "data-name": "Group 3662",
    transform: "translate(39.618 25.735)",
    style: {
      isolation: "isolate"
    }
  }, _g167 || (_g167 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3659",
    "data-name": "Group 3659",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10821",
    "data-name": "Path 10821",
    d: "M196.364,258.362l0,.516,4.686,2.723,0-.516Z",
    transform: "translate(-196.364 -258.362)",
    fill: "#e4eff7"
  }))), _g168 || (_g168 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3660",
    "data-name": "Group 3660",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10822",
    "data-name": "Path 10822",
    d: "M202.542,260.916l0,.516,5.638-3.255,0-.517Z",
    transform: "translate(-202.542 -257.661)",
    fill: "#e4eff7"
  }))), _g169 || (_g169 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3661",
    "data-name": "Group 3661"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10823",
    "data-name": "Path 10823",
    d: "M196.364,257.326l4.686,2.723,5.638-3.255L202,254.071Z",
    transform: "translate(-196.364 -254.071)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3666",
    "data-name": "Group 3666",
    transform: "translate(45.965 29.423)",
    style: {
      isolation: "isolate"
    }
  }, _g170 || (_g170 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3663",
    "data-name": "Group 3663",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10824",
    "data-name": "Path 10824",
    d: "M204.731,263.225l0,.516,4.695,2.728,0-.517Z",
    transform: "translate(-204.731 -263.225)",
    fill: "#e4eff7"
  }))), _g171 || (_g171 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3664",
    "data-name": "Group 3664",
    transform: "translate(4.695 2.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10825",
    "data-name": "Path 10825",
    d: "M210.921,265.785l0,.516,5.638-3.255,0-.516Z",
    transform: "translate(-210.921 -262.53)",
    fill: "#e4eff7"
  }))), _g172 || (_g172 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3665",
    "data-name": "Group 3665"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10826",
    "data-name": "Path 10826",
    d: "M204.731,262.188l4.695,2.728,5.638-3.255-4.7-2.728Z",
    transform: "translate(-204.731 -258.933)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3670",
    "data-name": "Group 3670",
    transform: "translate(52.321 33.116)",
    style: {
      isolation: "isolate"
    }
  }, _g173 || (_g173 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3667",
    "data-name": "Group 3667",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10827",
    "data-name": "Path 10827",
    d: "M213.11,268.094l0,.516,4.686,2.723,0-.516Z",
    transform: "translate(-213.11 -268.094)",
    fill: "#e4eff7"
  }))), _g174 || (_g174 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3668",
    "data-name": "Group 3668",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10828",
    "data-name": "Path 10828",
    d: "M219.287,270.648l0,.516,5.638-3.255,0-.516Z",
    transform: "translate(-219.287 -267.392)",
    fill: "#e4eff7"
  }))), _g175 || (_g175 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3669",
    "data-name": "Group 3669"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10829",
    "data-name": "Path 10829",
    d: "M213.11,267.057l4.686,2.723,5.638-3.255-4.686-2.723Z",
    transform: "translate(-213.11 -263.802)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3674",
    "data-name": "Group 3674",
    transform: "translate(59.278 37.159)",
    style: {
      isolation: "isolate"
    }
  }, _g176 || (_g176 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3671",
    "data-name": "Group 3671",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10830",
    "data-name": "Path 10830",
    d: "M222.281,273.424l0,.516,4.695,2.728,0-.516Z",
    transform: "translate(-222.281 -273.424)",
    fill: "#e4eff7"
  }))), _g177 || (_g177 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3672",
    "data-name": "Group 3672",
    transform: "translate(4.695 2.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10831",
    "data-name": "Path 10831",
    d: "M228.471,275.984l0,.517,5.638-3.255,0-.516Z",
    transform: "translate(-228.471 -272.729)",
    fill: "#e4eff7"
  }))), _g178 || (_g178 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3673",
    "data-name": "Group 3673"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10832",
    "data-name": "Path 10832",
    d: "M222.281,272.388l4.695,2.728,5.638-3.255-4.695-2.728Z",
    transform: "translate(-222.281 -269.132)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3678",
    "data-name": "Group 3678",
    transform: "translate(65.633 40.853)",
    style: {
      isolation: "isolate"
    }
  }, _g179 || (_g179 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3675",
    "data-name": "Group 3675",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10833",
    "data-name": "Path 10833",
    d: "M230.66,278.293l0,.516,4.686,2.723,0-.516Z",
    transform: "translate(-230.66 -278.293)",
    fill: "#e4eff7"
  }))), _g180 || (_g180 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3676",
    "data-name": "Group 3676",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10834",
    "data-name": "Path 10834",
    d: "M236.838,280.847l0,.516,5.638-3.255,0-.517Z",
    transform: "translate(-236.838 -277.591)",
    fill: "#e4eff7"
  }))), _g181 || (_g181 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3677",
    "data-name": "Group 3677"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10835",
    "data-name": "Path 10835",
    d: "M230.66,277.257l4.686,2.723,5.638-3.255L236.3,274Z",
    transform: "translate(-230.66 -274.001)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3682",
    "data-name": "Group 3682",
    transform: "translate(71.98 44.541)",
    style: {
      isolation: "isolate"
    }
  }, _g182 || (_g182 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3679",
    "data-name": "Group 3679",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10836",
    "data-name": "Path 10836",
    d: "M239.027,283.155l0,.516,4.686,2.723,0-.516Z",
    transform: "translate(-239.027 -283.155)",
    fill: "#e4eff7"
  }))), _g183 || (_g183 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3680",
    "data-name": "Group 3680",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10837",
    "data-name": "Path 10837",
    d: "M245.2,285.709l0,.516,5.638-3.255,0-.517Z",
    transform: "translate(-245.205 -282.454)",
    fill: "#e4eff7"
  }))), _g184 || (_g184 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3681",
    "data-name": "Group 3681"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10838",
    "data-name": "Path 10838",
    d: "M239.027,282.119l4.686,2.723,5.638-3.255-4.686-2.723Z",
    transform: "translate(-239.027 -278.864)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3686",
    "data-name": "Group 3686",
    transform: "translate(78.327 48.23)",
    style: {
      isolation: "isolate"
    }
  }, _g185 || (_g185 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3683",
    "data-name": "Group 3683",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10839",
    "data-name": "Path 10839",
    d: "M247.394,288.017l0,.516,4.695,2.728,0-.516Z",
    transform: "translate(-247.394 -288.017)",
    fill: "#e4eff7"
  }))), _g186 || (_g186 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3684",
    "data-name": "Group 3684",
    transform: "translate(4.695 2.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10840",
    "data-name": "Path 10840",
    d: "M253.583,290.578l0,.516,5.638-3.255,0-.517Z",
    transform: "translate(-253.583 -287.323)",
    fill: "#e4eff7"
  }))), _g187 || (_g187 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3685",
    "data-name": "Group 3685"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10841",
    "data-name": "Path 10841",
    d: "M247.394,286.981l4.695,2.728,5.638-3.255-4.695-2.728Z",
    transform: "translate(-247.394 -283.726)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3690",
    "data-name": "Group 3690",
    transform: "translate(84.683 51.923)",
    style: {
      isolation: "isolate"
    }
  }, _g188 || (_g188 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3687",
    "data-name": "Group 3687",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10842",
    "data-name": "Path 10842",
    d: "M255.773,292.887l0,.516,4.686,2.723,0-.516Z",
    transform: "translate(-255.773 -292.887)",
    fill: "#e4eff7"
  }))), _g189 || (_g189 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3688",
    "data-name": "Group 3688",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10843",
    "data-name": "Path 10843",
    d: "M261.95,295.441l0,.516,5.638-3.255,0-.516Z",
    transform: "translate(-261.95 -292.185)",
    fill: "#e4eff7"
  }))), _g190 || (_g190 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3689",
    "data-name": "Group 3689"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10844",
    "data-name": "Path 10844",
    d: "M255.773,291.851l4.686,2.723,5.638-3.255-4.686-2.723Z",
    transform: "translate(-255.773 -288.595)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3694",
    "data-name": "Group 3694",
    transform: "translate(91.029 55.612)",
    style: {
      isolation: "isolate"
    }
  }, _g191 || (_g191 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3691",
    "data-name": "Group 3691",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10845",
    "data-name": "Path 10845",
    d: "M264.14,297.749l0,.516,10.422,6.057,0-.516Z",
    transform: "translate(-264.14 -297.749)",
    fill: "#e4eff7"
  }))), _g192 || (_g192 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3692",
    "data-name": "Group 3692",
    transform: "translate(10.422 6.057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10846",
    "data-name": "Path 10846",
    d: "M277.88,304.7l0,.516,5.638-3.255,0-.516Z",
    transform: "translate(-277.88 -301.442)",
    fill: "#e4eff7"
  }))), _g193 || (_g193 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3693",
    "data-name": "Group 3693"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10847",
    "data-name": "Path 10847",
    d: "M264.14,296.713l10.422,6.057,5.638-3.255-10.422-6.057Z",
    transform: "translate(-264.14 -293.458)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3698",
    "data-name": "Group 3698",
    transform: "translate(21.842 23.643)",
    style: {
      isolation: "isolate"
    }
  }, _g194 || (_g194 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3695",
    "data-name": "Group 3695",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10848",
    "data-name": "Path 10848",
    d: "M172.93,255.6l0,.517,4.695,2.728,0-.516Z",
    transform: "translate(-172.93 -255.604)",
    fill: "#e4eff7"
  }))), _g195 || (_g195 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3696",
    "data-name": "Group 3696",
    transform: "translate(4.695 2.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10849",
    "data-name": "Path 10849",
    d: "M179.12,258.165l0,.516,5.638-3.255,0-.516Z",
    transform: "translate(-179.12 -254.91)",
    fill: "#e4eff7"
  }))), _g196 || (_g196 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3697",
    "data-name": "Group 3697"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10850",
    "data-name": "Path 10850",
    d: "M172.93,254.568l4.695,2.728,5.638-3.255-4.695-2.728Z",
    transform: "translate(-172.93 -251.313)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3702",
    "data-name": "Group 3702",
    transform: "translate(28.198 27.336)",
    style: {
      isolation: "isolate"
    }
  }, _g197 || (_g197 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3699",
    "data-name": "Group 3699",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10851",
    "data-name": "Path 10851",
    d: "M181.309,260.473l0,.517L186,263.713l0-.516Z",
    transform: "translate(-181.309 -260.473)",
    fill: "#e4eff7"
  }))), _g198 || (_g198 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3700",
    "data-name": "Group 3700",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10852",
    "data-name": "Path 10852",
    d: "M187.487,263.027l0,.517,5.638-3.255,0-.516Z",
    transform: "translate(-187.487 -259.772)",
    fill: "#e4eff7"
  }))), _g199 || (_g199 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3701",
    "data-name": "Group 3701"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10853",
    "data-name": "Path 10853",
    d: "M181.309,259.437,186,262.16l5.638-3.255-4.686-2.723Z",
    transform: "translate(-181.309 -256.182)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3706",
    "data-name": "Group 3706",
    transform: "translate(34.545 31.024)",
    style: {
      isolation: "isolate"
    }
  }, _g200 || (_g200 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3703",
    "data-name": "Group 3703",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10854",
    "data-name": "Path 10854",
    d: "M189.676,265.336l0,.517,4.686,2.723,0-.517Z",
    transform: "translate(-189.676 -265.336)",
    fill: "#e4eff7"
  }))), _g201 || (_g201 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3704",
    "data-name": "Group 3704",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10855",
    "data-name": "Path 10855",
    d: "M195.854,267.89l0,.516,5.638-3.255,0-.516Z",
    transform: "translate(-195.854 -264.634)",
    fill: "#e4eff7"
  }))), _g202 || (_g202 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3705",
    "data-name": "Group 3705"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10856",
    "data-name": "Path 10856",
    d: "M189.676,264.3l4.686,2.723L200,263.767l-4.686-2.723Z",
    transform: "translate(-189.676 -261.044)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3710",
    "data-name": "Group 3710",
    transform: "translate(40.891 34.713)",
    style: {
      isolation: "isolate"
    }
  }, _g203 || (_g203 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3707",
    "data-name": "Group 3707",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10857",
    "data-name": "Path 10857",
    d: "M198.043,270.2l0,.517,4.695,2.728,0-.517Z",
    transform: "translate(-198.043 -270.198)",
    fill: "#e4eff7"
  }))), _g204 || (_g204 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3708",
    "data-name": "Group 3708",
    transform: "translate(4.695 2.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10858",
    "data-name": "Path 10858",
    d: "M204.232,272.759l0,.517,5.638-3.255,0-.516Z",
    transform: "translate(-204.232 -269.504)",
    fill: "#e4eff7"
  }))), _g205 || (_g205 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3709",
    "data-name": "Group 3709"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10859",
    "data-name": "Path 10859",
    d: "M198.043,269.162l4.695,2.728,5.638-3.255-4.695-2.728Z",
    transform: "translate(-198.043 -265.907)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3714",
    "data-name": "Group 3714",
    transform: "translate(47.858 38.761)",
    style: {
      isolation: "isolate"
    }
  }, _g206 || (_g206 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3711",
    "data-name": "Group 3711",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10860",
    "data-name": "Path 10860",
    d: "M207.226,275.535l0,.516,4.686,2.723,0-.516Z",
    transform: "translate(-207.226 -275.535)",
    fill: "#e4eff7"
  }))), _g207 || (_g207 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3712",
    "data-name": "Group 3712",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10861",
    "data-name": "Path 10861",
    d: "M213.4,278.089l0,.516,5.638-3.255,0-.516Z",
    transform: "translate(-213.404 -274.834)",
    fill: "#e4eff7"
  }))), _g208 || (_g208 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3713",
    "data-name": "Group 3713"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10862",
    "data-name": "Path 10862",
    d: "M207.226,274.5l4.686,2.723,5.638-3.255-4.686-2.723Z",
    transform: "translate(-207.226 -271.243)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3718",
    "data-name": "Group 3718",
    transform: "translate(54.204 42.449)",
    style: {
      isolation: "isolate"
    }
  }, _g209 || (_g209 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3715",
    "data-name": "Group 3715",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10863",
    "data-name": "Path 10863",
    d: "M215.593,280.4l0,.517,4.695,2.728,0-.516Z",
    transform: "translate(-215.593 -280.397)",
    fill: "#e4eff7"
  }))), _g210 || (_g210 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3716",
    "data-name": "Group 3716",
    transform: "translate(4.695 2.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10864",
    "data-name": "Path 10864",
    d: "M221.783,282.958l0,.516,5.638-3.255,0-.516Z",
    transform: "translate(-221.783 -279.703)",
    fill: "#e4eff7"
  }))), _g211 || (_g211 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3717",
    "data-name": "Group 3717"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10865",
    "data-name": "Path 10865",
    d: "M215.593,279.361l4.695,2.728,5.638-3.255-4.695-2.728Z",
    transform: "translate(-215.593 -276.106)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3722",
    "data-name": "Group 3722",
    transform: "translate(60.56 46.143)",
    style: {
      isolation: "isolate"
    }
  }, _g212 || (_g212 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3719",
    "data-name": "Group 3719",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10866",
    "data-name": "Path 10866",
    d: "M223.972,285.266l0,.517,4.686,2.723,0-.516Z",
    transform: "translate(-223.972 -285.266)",
    fill: "#e4eff7"
  }))), _g213 || (_g213 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3720",
    "data-name": "Group 3720",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10867",
    "data-name": "Path 10867",
    d: "M230.15,287.82l0,.516,5.638-3.255,0-.516Z",
    transform: "translate(-230.15 -284.565)",
    fill: "#e4eff7"
  }))), _g214 || (_g214 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3721",
    "data-name": "Group 3721"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10868",
    "data-name": "Path 10868",
    d: "M223.972,284.23l4.686,2.723L234.3,283.7l-4.686-2.723Z",
    transform: "translate(-223.972 -280.975)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3726",
    "data-name": "Group 3726",
    transform: "translate(66.907 49.831)",
    style: {
      isolation: "isolate"
    }
  }, _g215 || (_g215 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3723",
    "data-name": "Group 3723",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10869",
    "data-name": "Path 10869",
    d: "M232.339,290.129l0,.516,4.686,2.723,0-.516Z",
    transform: "translate(-232.339 -290.129)",
    fill: "#e4eff7"
  }))), _g216 || (_g216 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3724",
    "data-name": "Group 3724",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10870",
    "data-name": "Path 10870",
    d: "M238.517,292.683l0,.516,5.638-3.255,0-.516Z",
    transform: "translate(-238.517 -289.427)",
    fill: "#e4eff7"
  }))), _g217 || (_g217 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3725",
    "data-name": "Group 3725"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10871",
    "data-name": "Path 10871",
    d: "M232.339,289.093l4.686,2.723,5.638-3.255-4.686-2.723Z",
    transform: "translate(-232.339 -285.837)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3730",
    "data-name": "Group 3730",
    transform: "translate(0 19.187)",
    style: {
      isolation: "isolate"
    }
  }, _g218 || (_g218 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3727",
    "data-name": "Group 3727",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10872",
    "data-name": "Path 10872",
    d: "M144.136,249.731l0,.516,7.029,4.085,0-.517Z",
    transform: "translate(-144.136 -249.731)",
    fill: "#e4eff7"
  }))), _g219 || (_g219 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3728",
    "data-name": "Group 3728",
    transform: "translate(7.029 4.085)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10873",
    "data-name": "Path 10873",
    d: "M153.4,254.08l0,.516,5.638-3.255,0-.516Z",
    transform: "translate(-153.402 -250.824)",
    fill: "#e4eff7"
  }))), _g220 || (_g220 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3729",
    "data-name": "Group 3729"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10874",
    "data-name": "Path 10874",
    d: "M144.136,248.695l7.029,4.085,5.638-3.255-7.029-4.085Z",
    transform: "translate(-144.136 -245.439)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3734",
    "data-name": "Group 3734",
    transform: "translate(8.384 24.06)",
    style: {
      isolation: "isolate"
    }
  }, _g221 || (_g221 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3731",
    "data-name": "Group 3731",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10875",
    "data-name": "Path 10875",
    d: "M155.189,256.154l0,.516,4.686,2.723,0-.517Z",
    transform: "translate(-155.189 -256.154)",
    fill: "#e4eff7"
  }))), _g222 || (_g222 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3732",
    "data-name": "Group 3732",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10876",
    "data-name": "Path 10876",
    d: "M161.366,258.708l0,.516,5.638-3.255,0-.516Z",
    transform: "translate(-161.366 -255.453)",
    fill: "#e4eff7"
  }))), _g223 || (_g223 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3733",
    "data-name": "Group 3733"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10877",
    "data-name": "Path 10877",
    d: "M155.189,255.118l4.686,2.723,5.638-3.255-4.686-2.723Z",
    transform: "translate(-155.189 -251.863)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3738",
    "data-name": "Group 3738",
    transform: "translate(14.731 27.748)",
    style: {
      isolation: "isolate"
    }
  }, _g224 || (_g224 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3735",
    "data-name": "Group 3735",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10878",
    "data-name": "Path 10878",
    d: "M163.556,261.017l0,.517,4.695,2.728,0-.517Z",
    transform: "translate(-163.556 -261.017)",
    fill: "#e4eff7"
  }))), _g225 || (_g225 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3736",
    "data-name": "Group 3736",
    transform: "translate(4.695 2.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10879",
    "data-name": "Path 10879",
    d: "M169.745,263.577l0,.517,5.638-3.255,0-.516Z",
    transform: "translate(-169.745 -260.322)",
    fill: "#e4eff7"
  }))), _g226 || (_g226 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3737",
    "data-name": "Group 3737"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10880",
    "data-name": "Path 10880",
    d: "M163.556,259.98l4.695,2.728,5.638-3.255-4.695-2.728Z",
    transform: "translate(-163.556 -256.725)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3742",
    "data-name": "Group 3742",
    transform: "translate(21.087 31.442)",
    style: {
      isolation: "isolate"
    }
  }, _g227 || (_g227 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3739",
    "data-name": "Group 3739",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10881",
    "data-name": "Path 10881",
    d: "M171.934,265.886l0,.517,4.686,2.723,0-.516Z",
    transform: "translate(-171.934 -265.886)",
    fill: "#e4eff7"
  }))), _g228 || (_g228 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3740",
    "data-name": "Group 3740",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10882",
    "data-name": "Path 10882",
    d: "M178.112,268.44l0,.516,5.638-3.255,0-.517Z",
    transform: "translate(-178.112 -265.184)",
    fill: "#e4eff7"
  }))), _g229 || (_g229 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3741",
    "data-name": "Group 3741"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10883",
    "data-name": "Path 10883",
    d: "M171.934,264.85l4.686,2.723,5.638-3.255-4.686-2.723Z",
    transform: "translate(-171.934 -261.594)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3746",
    "data-name": "Group 3746",
    transform: "translate(27.739 35.307)",
    style: {
      isolation: "isolate"
    }
  }, _g230 || (_g230 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3743",
    "data-name": "Group 3743",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10884",
    "data-name": "Path 10884",
    d: "M180.7,270.982l0,.516,34.705,20.168,0-.516Z",
    transform: "translate(-180.704 -270.982)",
    fill: "#e4eff7"
  }))), _g231 || (_g231 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3744",
    "data-name": "Group 3744",
    transform: "translate(34.705 20.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10885",
    "data-name": "Path 10885",
    d: "M226.456,296.534l0,.516L232.1,293.8l0-.516Z",
    transform: "translate(-226.456 -293.279)",
    fill: "#e4eff7"
  }))), _g232 || (_g232 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3745",
    "data-name": "Group 3745"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10886",
    "data-name": "Path 10886",
    d: "M180.7,269.946l34.705,20.168,5.638-3.255-34.705-20.168Z",
    transform: "translate(-180.704 -266.691)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3750",
    "data-name": "Group 3750",
    transform: "translate(73.254 53.519)",
    style: {
      isolation: "isolate"
    }
  }, _g233 || (_g233 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3747",
    "data-name": "Group 3747",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10887",
    "data-name": "Path 10887",
    d: "M240.706,294.991l0,.516,4.695,2.728,0-.517Z",
    transform: "translate(-240.706 -294.991)",
    fill: "#e4eff7"
  }))), _g234 || (_g234 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3748",
    "data-name": "Group 3748",
    transform: "translate(4.695 2.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10888",
    "data-name": "Path 10888",
    d: "M246.9,297.552l0,.516,5.638-3.255,0-.516Z",
    transform: "translate(-246.895 -294.297)",
    fill: "#e4eff7"
  }))), _g235 || (_g235 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3749",
    "data-name": "Group 3749"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10889",
    "data-name": "Path 10889",
    d: "M240.706,293.955l4.7,2.728,5.638-3.255-4.695-2.728Z",
    transform: "translate(-240.706 -290.7)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3754",
    "data-name": "Group 3754",
    transform: "translate(64.105 56.441)",
    style: {
      isolation: "isolate"
    }
  }, _g236 || (_g236 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3751",
    "data-name": "Group 3751",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10890",
    "data-name": "Path 10890",
    d: "M228.645,298.842l0,.516,4.695,2.728,0-.516Z",
    transform: "translate(-228.645 -298.842)",
    fill: "#e4eff7"
  }))), _g237 || (_g237 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3752",
    "data-name": "Group 3752",
    transform: "translate(4.695 2.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10891",
    "data-name": "Path 10891",
    d: "M234.834,301.4l0,.516,5.638-3.255,0-.516Z",
    transform: "translate(-234.834 -298.148)",
    fill: "#e4eff7"
  }))), _g238 || (_g238 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3753",
    "data-name": "Group 3753"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10892",
    "data-name": "Path 10892",
    d: "M228.645,297.806l4.695,2.728,5.638-3.255-4.695-2.728Z",
    transform: "translate(-228.645 -294.551)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3758",
    "data-name": "Group 3758",
    transform: "translate(79.609 57.213)",
    style: {
      isolation: "isolate"
    }
  }, _g239 || (_g239 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3755",
    "data-name": "Group 3755",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10893",
    "data-name": "Path 10893",
    d: "M249.085,299.86l0,.516,4.686,2.723,0-.516Z",
    transform: "translate(-249.085 -299.86)",
    fill: "#e4eff7"
  }))), _g240 || (_g240 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3756",
    "data-name": "Group 3756",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10894",
    "data-name": "Path 10894",
    d: "M255.262,302.414l0,.516,5.638-3.255,0-.516Z",
    transform: "translate(-255.262 -299.159)",
    fill: "#e4eff7"
  }))), _g241 || (_g241 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3757",
    "data-name": "Group 3757"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10895",
    "data-name": "Path 10895",
    d: "M249.085,298.824l4.686,2.723,5.638-3.255-4.686-2.723Z",
    transform: "translate(-249.085 -295.569)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3762",
    "data-name": "Group 3762",
    transform: "translate(70.46 60.134)",
    style: {
      isolation: "isolate"
    }
  }, _g242 || (_g242 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3759",
    "data-name": "Group 3759",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10896",
    "data-name": "Path 10896",
    d: "M237.024,303.711l0,.516,4.686,2.723,0-.516Z",
    transform: "translate(-237.024 -303.711)",
    fill: "#e4eff7"
  }))), _g243 || (_g243 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3760",
    "data-name": "Group 3760",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10897",
    "data-name": "Path 10897",
    d: "M243.2,306.265l0,.516,5.638-3.255,0-.516Z",
    transform: "translate(-243.201 -303.01)",
    fill: "#e4eff7"
  }))), _g244 || (_g244 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3761",
    "data-name": "Group 3761"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10898",
    "data-name": "Path 10898",
    d: "M237.024,302.675l4.686,2.723,5.638-3.255-4.686-2.723Z",
    transform: "translate(-237.024 -299.42)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3766",
    "data-name": "Group 3766",
    transform: "translate(85.651 60.724)",
    style: {
      isolation: "isolate"
    }
  }, _g245 || (_g245 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3763",
    "data-name": "Group 3763",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10899",
    "data-name": "Path 10899",
    d: "M257.049,304.489l0,.516,8.69,5.05,0-.516Z",
    transform: "translate(-257.049 -304.489)",
    fill: "#e4eff7"
  }))), _g246 || (_g246 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3764",
    "data-name": "Group 3764",
    transform: "translate(8.69 5.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10900",
    "data-name": "Path 10900",
    d: "M268.5,310.11l0,.516,5.638-3.255,0-.516Z",
    transform: "translate(-268.505 -306.855)",
    fill: "#e4eff7"
  }))), _g247 || (_g247 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3765",
    "data-name": "Group 3765"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10901",
    "data-name": "Path 10901",
    d: "M257.049,303.453l8.69,5.05,5.638-3.255-8.69-5.05Z",
    transform: "translate(-257.049 -300.197)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3770",
    "data-name": "Group 3770",
    transform: "translate(76.807 63.823)",
    style: {
      isolation: "isolate"
    }
  }, _g248 || (_g248 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3767",
    "data-name": "Group 3767",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10902",
    "data-name": "Path 10902",
    d: "M245.391,308.574l0,.517,4.686,2.723,0-.517Z",
    transform: "translate(-245.391 -308.574)",
    fill: "#e4eff7"
  }))), _g249 || (_g249 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3768",
    "data-name": "Group 3768",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10903",
    "data-name": "Path 10903",
    d: "M251.568,311.128l0,.516,5.638-3.255,0-.517Z",
    transform: "translate(-251.568 -307.872)",
    fill: "#e4eff7"
  }))), _g250 || (_g250 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3769",
    "data-name": "Group 3769"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10904",
    "data-name": "Path 10904",
    d: "M245.391,307.538l4.686,2.723,5.638-3.255-4.686-2.723Z",
    transform: "translate(-245.391 -304.282)",
    fill: "#e4eff7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3774",
    "data-name": "Group 3774",
    transform: "translate(82.543 67.156)",
    style: {
      isolation: "isolate"
    }
  }, _g251 || (_g251 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3771",
    "data-name": "Group 3771",
    transform: "translate(0 3.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10905",
    "data-name": "Path 10905",
    d: "M252.953,312.968l0,.516,4.686,2.723,0-.516Z",
    transform: "translate(-252.953 -312.968)",
    fill: "#e4eff7"
  }))), _g252 || (_g252 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3772",
    "data-name": "Group 3772",
    transform: "translate(4.686 2.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10906",
    "data-name": "Path 10906",
    d: "M259.13,315.522l0,.516,5.638-3.255,0-.516Z",
    transform: "translate(-259.13 -312.267)",
    fill: "#e4eff7"
  }))), _g253 || (_g253 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3773",
    "data-name": "Group 3773"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10907",
    "data-name": "Path 10907",
    d: "M252.953,311.932l4.686,2.723,5.638-3.255-4.686-2.723Z",
    transform: "translate(-252.953 -308.677)",
    fill: "#e4eff7"
  }))))), _g254 || (_g254 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3776",
    "data-name": "Group 3776",
    transform: "translate(0.004 134.916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10908",
    "data-name": "Path 10908",
    d: "M201.362,324.873a3.065,3.065,0,0,1-1.777-.556l-1.635-.957-3.27-1.913-6.539-3.825-13.108-7.6-26.217-15.2-26.275-15.1-13.139-7.55-6.583-3.75-3.292-1.876-1.645-.938c-.494-.328-1.271-.529-1.318-1.23.039.7.818.916,1.306,1.249l1.635.957,3.27,1.912,6.539,3.826,13.108,7.6,26.217,15.2,26.275,15.1,13.139,7.549,6.583,3.751,3.291,1.876,1.646.938A3.074,3.074,0,0,0,201.362,324.873Z",
    transform: "translate(-96.563 -264.367)",
    fill: "#fff"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10909",
    "data-name": "Path 10909",
    d: "M207.313,215l77.026,44.47a3.882,3.882,0,0,0,3.514,0l-80.541-46.5A1.071,1.071,0,0,0,207.313,215Z",
    transform: "translate(-123.124 -117.04)",
    fill: "#886cc3"
  }))))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10910",
    "data-name": "Path 10910",
    d: "M234.725,330.206V333.7a2.763,2.763,0,0,0,1.4-.328l73.224-42.547a1.013,1.013,0,0,0,.575-.8v-3.511a.971.971,0,0,1-.575.822l-73.2,42.547A2.9,2.9,0,0,1,234.725,330.206Z",
    transform: "translate(-129.918 -134.797)",
    fill: "#886cc3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10911",
    "data-name": "Path 10911",
    d: "M333.856,255.9l3.039-1.766a1,1,0,0,0,.41-.924l.226-88.133a4.776,4.776,0,0,0-.288-1.437l-3.018,1.664v.1a4.684,4.684,0,0,1,.287,1.417l-.246,88.154a1.367,1.367,0,0,1-.061.431.72.72,0,0,1-.144.308A.857.857,0,0,1,333.856,255.9Z",
    transform: "translate(-153.853 -105.13)",
    fill: "#886cc3"
  })), _g255 || (_g255 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3780",
    "data-name": "Group 3780",
    transform: "translate(106.224 152.534)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10912",
    "data-name": "Path 10912",
    d: "M309.8,287.592c-12.3,6.912-24.478,14.049-36.723,21.066-12.158,7.165-24.385,14.21-36.481,21.481,12.305-6.912,24.479-14.048,36.723-21.066C285.473,301.907,297.7,294.862,309.8,287.592Z",
    transform: "translate(-236.593 -287.592)",
    fill: "#bdb3f5"
  }))), _g256 || (_g256 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3781",
    "data-name": "Group 3781",
    transform: "translate(180.179 61.773)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10913",
    "data-name": "Path 10913",
    d: "M334.329,167.942c-.207,14.692-.155,29.384-.241,44.076.085,14.692.033,29.385.241,44.077.208-14.692.156-29.385.24-44.077C334.483,197.326,334.536,182.634,334.329,167.942Z",
    transform: "translate(-334.089 -167.942)",
    fill: "#bdb3f5"
  })))), _g257 || (_g257 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3795",
    "data-name": "Group 3795",
    transform: "translate(1085.946 203.542)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3783",
    "data-name": "Group 3783"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10914",
    "data-name": "Path 10914",
    d: "M173.958,145.1l51.565,29.771c.83.479,1.5.195,1.5-.635V101.267a3.115,3.115,0,0,0-1.5-2.37L173.958,69.126c-.83-.479-1.5-.194-1.5.635v72.967A3.117,3.117,0,0,0,173.958,145.1Z",
    transform: "translate(-172.456 -68.894)",
    fill: "url(#linear-gradient-43)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10915",
    "data-name": "Path 10915",
    d: "M225.883,110.62a1.593,1.593,0,0,0-.682-.95l-50.67-29.253.068,65.091a1.629,1.629,0,0,0,.681.947l50.682,29.262Z",
    transform: "translate(-172.957 -71.676)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10916",
    "data-name": "Path 10916",
    d: "M174.507,74.152a2.6,2.6,0,0,0,1.25,1.972c.69.4,1.25.162,1.25-.529a2.592,2.592,0,0,0-1.25-1.971C175.067,73.225,174.507,73.462,174.507,74.152Z",
    transform: "translate(-172.951 -69.989)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10917",
    "data-name": "Path 10917",
    d: "M178.706,76.6a2.592,2.592,0,0,0,1.25,1.971c.691.4,1.251.162,1.251-.528a2.591,2.591,0,0,0-1.251-1.972C179.266,75.669,178.706,75.906,178.706,76.6Z",
    transform: "translate(-173.965 -70.579)",
    fill: "#ff0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10918",
    "data-name": "Path 10918",
    d: "M182.906,79.049a2.6,2.6,0,0,0,1.25,1.972c.69.4,1.25.162,1.25-.529a2.6,2.6,0,0,0-1.25-1.972C183.466,78.122,182.906,78.358,182.906,79.049Z",
    transform: "translate(-174.979 -71.171)",
    fill: "#08ff00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3794",
    "data-name": "Group 3794",
    transform: "translate(9.397 29.937)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3788",
    "data-name": "Group 3788"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3784",
    "data-name": "Group 3784",
    transform: "translate(0 7.18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10919",
    "data-name": "Path 10919",
    d: "M194.475,122.558a3.987,3.987,0,0,1,1.933,3.074c0,1.063-.846,1.468-1.933.84a4.087,4.087,0,0,1-1.981-3.1C192.494,122.284,193.363,121.916,194.475,122.558Z",
    transform: "translate(-186.691 -118.891)",
    fill: "#b8acfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10920",
    "data-name": "Path 10920",
    d: "M186.825,118.141a3.986,3.986,0,0,1,1.934,3.074c0,1.063-.847,1.469-1.934.84a4.086,4.086,0,0,1-1.981-3.1C184.844,117.867,185.713,117.5,186.825,118.141Z",
    transform: "translate(-184.844 -117.825)",
    fill: "#b8acfd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3785",
    "data-name": "Group 3785"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10921",
    "data-name": "Path 10921",
    d: "M186.825,108.675a3.986,3.986,0,0,1,1.934,3.074c0,1.063-.847,1.469-1.934.84a4.086,4.086,0,0,1-1.981-3.1C184.844,108.4,185.713,108.033,186.825,108.675Z",
    transform: "translate(-184.844 -108.359)",
    fill: "#b8acfd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10922",
    "data-name": "Path 10922",
    d: "M194.6,112.745l26.616,15.367a3.988,3.988,0,0,1,1.933,3.074c0,1.063-.846,1.469-1.933.84L194.6,116.659a4.087,4.087,0,0,1-1.981-3.1C192.618,112.471,193.487,112.1,194.6,112.745Z",
    transform: "translate(-186.721 -109.342)",
    fill: "#b8acfd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3786",
    "data-name": "Group 3786",
    transform: "translate(0 14.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10923",
    "data-name": "Path 10923",
    d: "M186.825,128.444a3.986,3.986,0,0,1,1.934,3.074c0,1.063-.847,1.469-1.934.841a4.087,4.087,0,0,1-1.981-3.1C184.844,128.171,185.713,127.8,186.825,128.444Z",
    transform: "translate(-184.844 -128.129)",
    fill: "#b8acfd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10924",
    "data-name": "Path 10924",
    d: "M194.6,132.514l26.616,15.367a3.986,3.986,0,0,1,1.933,3.074c0,1.063-.846,1.469-1.933.841L194.6,136.428a4.086,4.086,0,0,1-1.981-3.1C192.618,132.24,193.487,131.872,194.6,132.514Z",
    transform: "translate(-186.721 -114.115)",
    fill: "#b8acfd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3787",
    "data-name": "Group 3787",
    transform: "translate(0 7.18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10925",
    "data-name": "Path 10925",
    d: "M186.825,118.141a3.986,3.986,0,0,1,1.934,3.074c0,1.063-.847,1.469-1.934.84a4.086,4.086,0,0,1-1.981-3.1C184.844,117.867,185.713,117.5,186.825,118.141Z",
    transform: "translate(-184.844 -117.825)",
    fill: "#b8acfd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10926",
    "data-name": "Path 10926",
    d: "M202.31,127.09l20.652,11.924a4.1,4.1,0,0,1,2.025,3.128c0,1.063-.886,1.444-2.025.787L202.31,131a4.212,4.212,0,0,1-2.076-3.156C200.234,126.762,201.145,126.417,202.31,127.09Z",
    transform: "translate(-188.56 -112.798)",
    fill: "#b8acfd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3793",
    "data-name": "Group 3793",
    transform: "translate(0 23.167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3789",
    "data-name": "Group 3789",
    transform: "translate(0 7.181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10927",
    "data-name": "Path 10927",
    d: "M194.475,153.1a3.987,3.987,0,0,1,1.933,3.074c0,1.064-.846,1.468-1.933.84a4.087,4.087,0,0,1-1.981-3.1C192.494,152.825,193.363,152.457,194.475,153.1Z",
    transform: "translate(-186.691 -149.432)",
    fill: "#b8acfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10928",
    "data-name": "Path 10928",
    d: "M186.825,148.682a3.986,3.986,0,0,1,1.934,3.074c0,1.063-.847,1.469-1.934.84a4.086,4.086,0,0,1-1.981-3.1C184.844,148.408,185.713,148.04,186.825,148.682Z",
    transform: "translate(-184.844 -148.366)",
    fill: "#b8acfd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3790",
    "data-name": "Group 3790"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10929",
    "data-name": "Path 10929",
    d: "M186.825,139.216a3.989,3.989,0,0,1,1.934,3.074c0,1.063-.847,1.469-1.934.84a4.087,4.087,0,0,1-1.981-3.1C184.844,138.942,185.713,138.574,186.825,139.216Z",
    transform: "translate(-184.844 -138.9)",
    fill: "#b8acfd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10930",
    "data-name": "Path 10930",
    d: "M194.6,143.285l26.616,15.367a3.988,3.988,0,0,1,1.933,3.074c0,1.064-.846,1.468-1.933.84L194.6,147.2a4.087,4.087,0,0,1-1.981-3.1C192.618,143.012,193.487,142.644,194.6,143.285Z",
    transform: "translate(-186.721 -139.882)",
    fill: "#b8acfd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3791",
    "data-name": "Group 3791",
    transform: "translate(0 14.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10931",
    "data-name": "Path 10931",
    d: "M186.825,158.986a3.986,3.986,0,0,1,1.934,3.074c0,1.063-.847,1.469-1.934.841a4.088,4.088,0,0,1-1.981-3.1C184.844,158.712,185.713,158.344,186.825,158.986Z",
    transform: "translate(-184.844 -158.67)",
    fill: "#b8acfd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10932",
    "data-name": "Path 10932",
    d: "M194.6,163.055l26.616,15.367a3.986,3.986,0,0,1,1.933,3.074c0,1.063-.846,1.469-1.933.84L194.6,166.969a4.087,4.087,0,0,1-1.981-3.1C192.618,162.781,193.487,162.413,194.6,163.055Z",
    transform: "translate(-186.721 -144.656)",
    fill: "#b8acfd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3792",
    "data-name": "Group 3792",
    transform: "translate(0 7.181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10933",
    "data-name": "Path 10933",
    d: "M186.825,148.682a3.986,3.986,0,0,1,1.934,3.074c0,1.063-.847,1.469-1.934.84a4.086,4.086,0,0,1-1.981-3.1C184.844,148.408,185.713,148.04,186.825,148.682Z",
    transform: "translate(-184.844 -148.366)",
    fill: "#b8acfd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10934",
    "data-name": "Path 10934",
    d: "M202.31,157.631l20.652,11.924a4.1,4.1,0,0,1,2.025,3.127c0,1.064-.886,1.445-2.025.787L202.31,161.545a4.212,4.212,0,0,1-2.076-3.156C200.234,157.3,201.145,156.958,202.31,157.631Z",
    transform: "translate(-188.56 -143.339)",
    fill: "#b8acfd"
  }))))), _g258 || (_g258 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3835",
    "data-name": "Group 3835",
    transform: "translate(1182.732 255.512) rotate(173)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3833",
    "data-name": "Group 3833",
    transform: "translate(5.692 4.878)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11010",
    "data-name": "Path 11010",
    d: "M3.132,10.825c1.407.812,2.5.881,3.344.372L5.22,9.489A1.812,1.812,0,0,1,3.3,9.378,2.234,2.234,0,0,1,2.027,7.585c0-1.422,2.512.24,2.512-2.348v-.59l-1.8-1.039v.514C2.738,5.952,0,4.129,0,6.565,0,7.852,1.059,9.628,3.132,10.825Zm.484-8.179c.681.393,1.211.153,1.211-.527A2.519,2.519,0,0,0,3.616.195C2.92-.207,2.375.038,2.375.7A2.537,2.537,0,0,0,3.616,2.646Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3834",
    "data-name": "Group 3834",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11011",
    "data-name": "Path 11011",
    d: "M0,5.153C0,10.078,4.006,16.4,8.93,19.24s8.931,1.15,8.931-3.775S13.855,4.223,8.93,1.38,0,.23,0,5.153Zm1.261.728C1.261,1.653,4.7.2,8.93,2.641s7.67,7.868,7.67,12.1-3.441,5.683-7.67,3.241S1.261,10.111,1.261,5.882Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-13)"
  })))), _g259 || (_g259 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3838",
    "data-name": "Group 3838",
    transform: "translate(1148.88 292.617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3836",
    "data-name": "Group 3836",
    transform: "translate(6.973 4.042)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11012",
    "data-name": "Path 11012",
    d: "M262.143,172.4a1.984,1.984,0,0,1,1,1.559c0,.539-.413.727-1,.386a1.993,1.993,0,0,1-1.016-1.553C261.127,172.241,261.541,172.055,262.143,172.4Zm-.816,2.892,1.607.927v6.64l-1.607-.927Z",
    transform: "translate(-261.127 -172.226)",
    fill: "url(#linear-gradient-13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3837",
    "data-name": "Group 3837"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11013",
    "data-name": "Path 11013",
    d: "M251.935,171.5c0-4.4,3.581-5.914,7.983-3.372s7.983,8.189,7.983,12.59-3.581,5.916-7.983,3.375S251.935,175.906,251.935,171.5Zm1.046.6c0,3.825,3.112,8.733,6.937,10.942s6.936.893,6.936-2.933-3.112-8.732-6.936-10.941S252.981,168.285,252.981,172.108Z",
    transform: "translate(-251.935 -166.898)",
    fill: "url(#linear-gradient-13)"
  })))), _g260 || (_g260 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3842",
    "data-name": "Group 3842",
    transform: "translate(1064.925 210.666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11014",
    "data-name": "Path 11014",
    d: "M143.6,98.5l51.234,29.58c1.292.746,2.339.3,2.339-.988v-15.17a4.852,4.852,0,0,0-2.339-3.69L143.6,78.647c-1.292-.746-2.339-.3-2.339.989v15.17A4.852,4.852,0,0,0,143.6,98.5Z",
    transform: "translate(-141.257 -78.285)",
    fill: "url(#linear-gradient-48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11015",
    "data-name": "Path 11015",
    d: "M196.308,112.324a3.627,3.627,0,0,0-1.707-2.6l-51.234-29.58a1.534,1.534,0,0,0-.44-.181c0,.021,0,15.245,0,15.245a3.627,3.627,0,0,0,1.707,2.6l51.235,29.58a1.552,1.552,0,0,0,.439.182C196.307,127.548,196.308,112.324,196.308,112.324Z",
    transform: "translate(-141.659 -78.691)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3841",
    "data-name": "Group 3841",
    transform: "translate(7.03 7.983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3839",
    "data-name": "Group 3839",
    transform: "translate(7.282 4.188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11016",
    "data-name": "Path 11016",
    d: "M161.368,94.528a2.5,2.5,0,0,1,1.213,1.929c0,.668-.531.921-1.213.527a2.564,2.564,0,0,1-1.243-1.946C160.125,94.356,160.67,94.125,161.368,94.528Z",
    transform: "translate(-160.125 -94.33)",
    fill: "#bdb3f5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11017",
    "data-name": "Path 11017",
    d: "M166.375,100.139,194.717,116.5c.661.382,1.2.155,1.2-.507a2.488,2.488,0,0,0-1.2-1.891L166.375,97.741c-.662-.382-1.2-.156-1.2.507A2.486,2.486,0,0,0,166.375,100.139Z",
    transform: "translate(-154.062 -90.92)",
    fill: "#bdb3f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11018",
    "data-name": "Path 11018",
    d: "M179.123,118.672l18.672,10.781c.661.382,1.2.155,1.2-.507a2.488,2.488,0,0,0-1.2-1.891l-18.672-10.781c-.662-.382-1.2-.155-1.2.507A2.486,2.486,0,0,0,179.123,118.672Z",
    transform: "translate(-157.14 -95.395)",
    fill: "#bdb3f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11019",
    "data-name": "Path 11019",
    d: "M151.952,102.985l16.5,9.528c.662.382,1.2.156,1.2-.507a2.483,2.483,0,0,0-1.2-1.89l-16.5-9.529c-.662-.382-1.2-.155-1.2.507A2.487,2.487,0,0,0,151.952,102.985Z",
    transform: "translate(-150.58 -91.607)",
    fill: "#bdb3f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3840",
    "data-name": "Group 3840",
    transform: "translate(0 4.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11020",
    "data-name": "Path 11020",
    d: "M151.768,94.572a2.5,2.5,0,0,1,1.213,1.929c0,.667-.531.921-1.213.527a2.564,2.564,0,0,1-1.243-1.946C150.525,94.4,151.07,94.169,151.768,94.572Z",
    transform: "translate(-150.525 -94.374)",
    fill: "#bdb3f5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11021",
    "data-name": "Path 11021",
    d: "M188.455,118.473l11.593,6.693c.661.382,1.2.156,1.2-.507a2.486,2.486,0,0,0-1.2-1.89l-11.593-6.693c-.662-.382-1.2-.156-1.2.507A2.484,2.484,0,0,0,188.455,118.473Z",
    transform: "translate(-159.394 -95.347)",
    fill: "#bdb3f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11022",
    "data-name": "Path 11022",
    d: "M172.469,109.244l7.7,4.444c.662.382,1.2.155,1.2-.507a2.487,2.487,0,0,0-1.2-1.89l-7.7-4.444c-.661-.382-1.2-.155-1.2.507A2.488,2.488,0,0,0,172.469,109.244Z",
    transform: "translate(-155.534 -93.119)",
    fill: "#bdb3f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11023",
    "data-name": "Path 11023",
    d: "M156.483,100.014l7.7,4.444c.662.382,1.2.155,1.2-.507a2.486,2.486,0,0,0-1.2-1.891l-7.7-4.444c-.662-.382-1.2-.156-1.2.507A2.486,2.486,0,0,0,156.483,100.014Z",
    transform: "translate(-151.674 -90.89)",
    fill: "#bdb3f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11024",
    "data-name": "Path 11024",
    d: "M151.724,91.392l2.943,1.7c.662.382,1.2.155,1.2-.507a2.485,2.485,0,0,0-1.2-1.89l-2.943-1.7c-.662-.382-1.2-.156-1.2.507A2.486,2.486,0,0,0,151.724,91.392Z",
    transform: "translate(-150.525 -88.808)",
    fill: "#bdb3f5"
  })))), _g261 || (_g261 = /*#__PURE__*/React.createElement("g", {
    id: "face",
    transform: "translate(1226.981 331.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10271",
    "data-name": "Path 10271",
    d: "M0,0,.478.8S.637,2.523.744,2.842s.744.319,1.089.106",
    transform: "translate(1.408 0.544) rotate(16)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10272",
    "data-name": "Path 10272",
    d: "M0,1.461A1.664,1.664,0,0,0,2.045,0",
    transform: "translate(1.73 3.241) rotate(16)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10273",
    "data-name": "Path 10273",
    d: "M.744,0S.159.053,0,.425",
    transform: "translate(0.117 0.098) rotate(16)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10274",
    "data-name": "Path 10274",
    d: "M0,.294A1.8,1.8,0,0,1,1.779.188",
    transform: "translate(2.383 0) rotate(16)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10275",
    "data-name": "Path 10275",
    d: "M.5.345C.551.558.5.77.366.8S.1.69.02.451C-.033.239.02.027.153,0,.312,0,.445.133.5.345Z",
    transform: "translate(2.945 1.241) rotate(16)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10276",
    "data-name": "Path 10276",
    d: "M.5.348C.551.561.5.773.366.8S.1.693.02.454C-.033.242.02.029.153,0S.445.136.5.348Z",
    transform: "translate(0.389 1.196) rotate(16)",
    fill: "#263238"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "isomatric_coin",
    "data-name": "isomatric coin",
    d: "M10.169,5.044a3.045,3.045,0,0,1,.3,1.238,1.6,1.6,0,0,1-1.141,1.6A3.045,3.045,0,0,1,8.06,8M5.73,2.364a2.069,2.069,0,0,0-1.038.413,1.517,1.517,0,0,0-.53.852A2.324,2.324,0,0,0,4.22,4.79a4.4,4.4,0,0,0,.639,1.294m7.954-.4c1.281,2.811-.173,4.85-3.248,4.554A10.707,10.707,0,0,1,1.677,4.61C.4,1.8,1.85-.24,4.925.056A10.707,10.707,0,0,1,12.813,5.68Zm-.1-.176c1.588,2.943.222,6.087-3.121,5.991a11.591,11.591,0,0,1-8.928-5.5C-.927,3.05.439-.094,3.781,0A11.591,11.591,0,0,1,12.71,5.5Z",
    transform: "translate(969.5 359.161)",
    fill: "none",
    stroke: "#fbb516",
    strokeWidth: 1.5
  })), _g262 || (_g262 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2742",
    "data-name": "Group 2742",
    transform: "translate(1177.455 206.652)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_306",
    "data-name": "Rectangle 306",
    width: 1.579,
    height: 4.607,
    transform: "matrix(0.248, 0.969, -0.969, 0.248, 11.299, 0)",
    fill: "#91288c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_307",
    "data-name": "Rectangle 307",
    width: 1.579,
    height: 4.607,
    transform: "translate(9.023 2.219) rotate(75.623)",
    fill: "#91288c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_308",
    "data-name": "Rectangle 308",
    width: 1.579,
    height: 4.607,
    transform: "translate(6.759 4.445) rotate(75.623)",
    fill: "#91288c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_309",
    "data-name": "Rectangle 309",
    width: 1.579,
    height: 4.607,
    transform: "matrix(0.248, 0.969, -0.969, 0.248, 4.463, 6.649)",
    fill: "#91288c"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10221",
    "data-name": "Path 10221",
    d: "M3.975,12.075,0,3.975,8.1,0l3.975,8.1ZM2.415,4.793l2.4,4.867,4.867-2.4L7.282,2.4Z",
    transform: "translate(1150.292 439.931)",
    fill: "#91288c"
  })), _g263 || (_g263 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2743",
    "data-name": "Group 2743",
    transform: "translate(1215.247 247.309) rotate(-29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9767",
    "data-name": "Path 9767",
    d: "M2.985.5l-2.6,2.22L0,0Z",
    transform: "translate(5.664 12.477)",
    fill: "url(#linear-gradient-49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9768",
    "data-name": "Path 9768",
    d: "M.187,0,0,12.281a.872.872,0,0,0,.884.885l12.333-.272a.345.345,0,0,0,.23-.6Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-50)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9769",
    "data-name": "Path 9769",
    d: "M8.463,12.979,0,0,6.473,13.03l-.7.646Z",
    transform: "translate(0.187 0)",
    fill: "url(#linear-gradient-51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9770",
    "data-name": "Path 9770",
    d: "M0,.025.57,2.169,1.182,0Z",
    transform: "translate(5.477 13.03)",
    fill: "url(#linear-gradient-49)"
  }))), _g264 || (_g264 = /*#__PURE__*/React.createElement("g", {
    id: "Glass_Triangle1",
    "data-name": "Glass Triangle1",
    transform: "matrix(0.934, 0.358, -0.358, 0.934, 985.392, 264.691)",
    fill: "rgba(255,255,255,0.3)",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.685,13.37,13.37,0H0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.685175895690918 8.898228645324707 L 10.13429069519043 1.999998331069946 L 3.236060857772827 1.999998331069946 L 6.685175895690918 8.898228645324707 M 6.685175895690918 13.37035846710205 L -4.104309027752606e-06 -1.720123236736981e-06 L 13.3703556060791 -1.720123236736981e-06 L 6.685175895690918 13.37035846710205 Z",
    stroke: "none",
    fill: "rgba(255,255,255,0.75)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3942",
    "data-name": "Group 3942",
    transform: "translate(1093.461 288.234)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3939",
    "data-name": "Group 3939",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11293",
    "data-name": "Path 11293",
    d: "M484.975,170.529l-7.861,4.684L465.862,168.2v63.672l47.021,37.1,11.547-7.1V193.309Z",
    transform: "translate(-431.921 -158.432)",
    fill: "url(#linear-gradient-53)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11294",
    "data-name": "Path 11294",
    d: "M470.8,171.877v5.475l-36.748-21.215a1.947,1.947,0,0,0-2.921,1.686V225.43l70.113,40.752a5.145,5.145,0,0,0,5.3-.075l1.5-.928a4.689,4.689,0,0,0,2.219-3.986V194.345a5.3,5.3,0,0,0-2.651-4.592l-33.884-19.562A1.947,1.947,0,0,0,470.8,171.877Z",
    transform: "translate(-424.712 -155.873)",
    fill: "url(#linear-gradient-54)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3938",
    "data-name": "Group 3938",
    transform: "translate(6.769 0.002)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11295",
    "data-name": "Path 11295",
    d: "M433.344,156.807l36.748,21.216v-1.134l-35.944-20.752a1.94,1.94,0,0,0-2.577.6A1.909,1.909,0,0,1,433.344,156.807Z",
    transform: "translate(-431.571 -155.876)",
    fill: "url(#radial-gradient)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11296",
    "data-name": "Path 11296",
    d: "M518.091,193.436l-33.884-19.562a1.94,1.94,0,0,0-2.577.6,1.909,1.909,0,0,1,1.773.074l33.884,19.562a5.3,5.3,0,0,1,2.651,4.592v66.849a4.688,4.688,0,0,1-1.283,3.222,4.684,4.684,0,0,0,2.086-3.892v-66.85A5.3,5.3,0,0,0,518.091,193.436Z",
    transform: "translate(-441.963 -159.557)",
    fill: "url(#radial-gradient-2)"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11297",
    "data-name": "Path 11297",
    d: "M426.579,220.322,505.7,266V205.957l-79.125-45.683Z",
    transform: "translate(-423.766 -156.787)",
    fill: "#481047"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11298",
    "data-name": "Path 11298",
    d: "M426.579,223.869,504.3,268.743V212.585l-77.724-44.874Z",
    transform: "translate(-423.766 -158.33)",
    fill: "#e6cfc8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11299",
    "data-name": "Path 11299",
    d: "M426.457,226.719,499.7,269a5.086,5.086,0,0,0,4.956.073l.478-.257-.5.191a1.826,1.826,0,0,1-2.479-1.706v-50.28a5.3,5.3,0,0,0-2.651-4.592l-73.553-42.465a1.948,1.948,0,0,0-2.922,1.686v49.129A6.857,6.857,0,0,0,426.457,226.719Z",
    transform: "translate(-423.029 -158.744)",
    fill: "url(#linear-gradient-55)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11300",
    "data-name": "Path 11300",
    d: "M504.762,269.01a1.825,1.825,0,0,1-2.479-1.705v-50.28a5.3,5.3,0,0,0-2.651-4.592L426.08,169.968a1.934,1.934,0,0,0-2.428.408,1.906,1.906,0,0,1,1.724.094l73.553,42.465a5.3,5.3,0,0,1,2.651,4.591v50.281a1.826,1.826,0,0,0,1.573,1.809,5.08,5.08,0,0,0,1.628-.539l.479-.258Z",
    transform: "translate(-423.158 -158.745)",
    fill: "url(#radial-gradient-3)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3941",
    "data-name": "Group 3941",
    transform: "translate(20.532 34.38)"
  }, _g265 || (_g265 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3940",
    "data-name": "Group 3940",
    transform: "translate(0.055)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11301",
    "data-name": "Path 11301",
    d: "M488.126,219.911c-6.338-3.6-12.534-9.378-17.726-16.542l-.071-.04c-5.193,1.168-11.389-.2-17.726-3.926l-.242-.142-3.35,1.907,3.843,2.529c1.2,16.04,7.463,29.208,17.538,44.8l.246.142c1.811-.712-.933.927.624.049.067-.038,4.415-2.362,4.482-2.4,6.989-4.01,11.305-10.163,12.282-22.067l.342-4.167Z",
    transform: "translate(-449.01 -199.26)",
    fill: "#481047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11302",
    "data-name": "Path 11302",
    d: "M490.344,220.977c-6.338-3.6-12.534-9.378-17.726-16.542l-.071-.04-.1.021L459.7,211.783l26.111,11.977,4.78-2.646Z",
    transform: "translate(-451.228 -200.326)",
    fill: "#481047"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11303",
    "data-name": "Path 11303",
    d: "M485.295,221.983c-6.337-3.6-12.534-9.378-17.726-16.542l-.071-.04c-5.193,1.167-11.388-.2-17.726-3.926l-.242-.142.342,4.563c1.2,16.039,7.463,29.208,17.539,44.8l.245.142c10.076-3.956,16.337-9.895,17.539-24.546l.342-4.167Z",
    transform: "translate(-449.062 -199.69)",
    fill: "url(#linear-gradient-56)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11304",
    "data-name": "Path 11304",
    d: "M484.706,222.219c-6.338-3.6-12.534-9.378-17.726-16.542l-.07-.041c-5.194,1.168-11.389-.2-17.726-3.926l-.242-.143.342,4.563c1.2,16.04,7.463,29.208,17.538,44.8l.246.142c10.076-3.956,16.336-9.895,17.539-24.546l.342-4.168Z",
    transform: "translate(-448.94 -199.739)",
    fill: "url(#linear-gradient-57)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11307",
    "data-name": "Path 11307",
    d: "M468.295,249.582c-9.057-14.173-15.294-26.97-16.473-42.7l-.075-1a28.086,28.086,0,0,0,11.98,3.015,19.625,19.625,0,0,0,2.951-.22,60.018,60.018,0,0,0,16.8,15.649l-.24,2.93C482.127,240.727,476.717,245.993,468.295,249.582Z",
    transform: "translate(-449.522 -200.635)",
    fill: "#481047"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11308",
    "data-name": "Path 11308",
    d: "M453.091,206.643l-.012-.155q-.664-.286-1.333-.6l.075,1c1.18,15.733,7.416,28.53,16.473,42.7.376-.16.744-.326,1.108-.493C460.433,235.019,454.263,222.281,453.091,206.643Z",
    transform: "translate(-449.522 -200.635)",
    opacity: 0.2,
    fill: "url(#radial-gradient-4)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11309",
    "data-name": "Path 11309",
    d: "M473.45,238.286l-3.416-1.972V220.656l3.416,1.972Z",
    transform: "translate(-453.319 -203.702)",
    fill: "url(#linear-gradient-58)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11310",
    "data-name": "Path 11310",
    d: "M471.072,235.645v-14.39l-1.038-.6v15.658l3.416,1.972v-1.269Z",
    transform: "translate(-453.319 -203.702)",
    fill: "#481047",
    opacity: 0.7,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3943",
    "data-name": "Group 3943",
    transform: "translate(1088.55 343.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11267",
    "data-name": "Path 11267",
    d: "M329.2,211.638l-.029-.019-1.061-.682-25.478,14.71v10.158l1.061-.613v1.21l12.9-9.264,12.579-6.938V211.68Z",
    transform: "translate(-284.337 -210.938)",
    fill: "#e4eff7",
    opacity: 0.45,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11268",
    "data-name": "Path 11268",
    d: "M319.738,215.755l-25.478,14.71v10.158l17.4-10.047.5-1.781,8.668-12.34Z",
    transform: "translate(-279.769 -213.568)",
    fill: "url(#linear-gradient-59)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11269",
    "data-name": "Path 11269",
    d: "M322.075,217.07,296.6,231.78v10.158L314,231.891l.5-1.781,7.578-4.375Z",
    transform: "translate(-281.045 -214.286)",
    fill: "#481047"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11270",
    "data-name": "Path 11270",
    d: "M322.086,230.925l-19.993,11.552v-5.009l19.993-11.552Z",
    transform: "translate(-284.045 -219.115)",
    fill: "url(#linear-gradient-60)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11271",
    "data-name": "Path 11271",
    d: "M321.74,226.116v4.665l-19.648,11.353v.344l19.993-11.552v-5.009Z",
    transform: "translate(-284.045 -219.115)",
    fill: "#8b8c9e"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11272",
    "data-name": "Path 11272",
    d: "M282.764,236.562l-1.682-.87a1.512,1.512,0,0,0-1.611.121l-7.289,4.208a4.847,4.847,0,0,0-2.2,3.794v14.844a1.437,1.437,0,0,0,.806,1.487l1.71.911.027-.857c.036-.019.071-.035.107-.055l7.289-4.209a4.846,4.846,0,0,0,2.2-3.794V237.3c0-.079,0-.153-.01-.226Zm-5.436,14.566a4.384,4.384,0,0,1-1.99,3.432l-.42.242c-1.1.634-1.99.127-1.99-1.134v-1.983l1.412-8.285a3.286,3.286,0,0,1,.578-.443l.42-.243c1.1-.634,1.99-.126,1.99,1.135Z",
    transform: "translate(-266.516 -224.353)",
    fill: "#481047"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11273",
    "data-name": "Path 11273",
    d: "M283.238,237.783l-7.289,4.208a4.848,4.848,0,0,0-2.2,3.794v14.844c0,1.394.985,1.955,2.2,1.254l7.289-4.208a4.845,4.845,0,0,0,2.2-3.794V239.037C285.438,237.643,284.453,237.081,283.238,237.783Zm-2.594,15.083a4.384,4.384,0,0,1-1.99,3.432l-.42.242c-1.1.634-1.99.127-1.99-1.134v-7.28a4.384,4.384,0,0,1,1.99-3.432l.42-.242c1.1-.634,1.99-.126,1.99,1.135Z",
    transform: "translate(-268.573 -225.428)",
    fill: "url(#linear-gradient-61)"
  })), _g266 || (_g266 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3935",
    "data-name": "Group 3935",
    transform: "translate(0 8.526)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11276",
    "data-name": "Path 11276",
    d: "M274.217,263.582l15.522-9.893,15.522-9.893A3.232,3.232,0,0,0,307.014,241c0-1.24.173-9.788-1.169-10.562l-1.689-.691c-1.053-.608-3.312,6.45-4.651,6.45a6.121,6.121,0,0,0-3.055.737l-16.174,9.338L264.1,255.613a3.232,3.232,0,0,0-1.753,2.792,3.76,3.76,0,0,0,2.111,3.17S273.382,264.064,274.217,263.582Z",
    transform: "translate(-262.349 -229.713)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11277",
    "data-name": "Path 11277",
    d: "M306.486,232.435c-.034.005-1.6-.615-1.633-.608-1.151-.505-3.343,6.008-4.63,6.028a6.381,6.381,0,0,0-2.926.756l-15.584,9-15.587,9a3.41,3.41,0,0,0-1.721,2.3c-.015.108-.029.218-.035.328a3.43,3.43,0,0,0,1.958,3.054s.623.332,1.4.707c1.618.787,4.152,1.894,5.042,1.864.233,0,.462-.022.684-.045a5.955,5.955,0,0,0,2.232-.709l14.907-9.523,1.275-.815,13.632-8.709a3.255,3.255,0,0,0,1.742-2.637c0-.289.083-1.078.1-2.01a32.974,32.974,0,0,0-.184-6.2C306.982,233.357,306.8,232.614,306.486,232.435Z",
    transform: "translate(-263.45 -230.852)",
    opacity: 0.091
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11278",
    "data-name": "Path 11278",
    d: "M307.119,234.429c-.068.011-1.515-.54-1.578-.524-1.248-.4-3.373,5.564-4.61,5.6a6.726,6.726,0,0,0-2.8.775l-14.993,8.656-15,8.66a3.57,3.57,0,0,0-1.709,2.167c-.017.1-.038.2-.049.307a3.113,3.113,0,0,0,1.8,2.938s.639.349,1.34.69c1.55.753,3.958,1.768,4.85,1.709.223-.008.441-.033.653-.058a6.2,6.2,0,0,0,2.125-.716l14.291-9.152,1.223-.783,13.069-8.369a3.307,3.307,0,0,0,1.732-2.483c0-.26.155-1.039.191-1.877.072-1.7.429-4.194.049-5.825C307.53,235.378,307.4,234.59,307.119,234.429Z",
    transform: "translate(-264.543 -231.991)",
    opacity: 0.182
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11279",
    "data-name": "Path 11279",
    d: "M307.743,236.421c-.1.017-1.429-.465-1.522-.441-1.346-.3-3.4,5.122-4.59,5.182a7.2,7.2,0,0,0-2.669.794l-14.4,8.316-14.413,8.321a3.8,3.8,0,0,0-1.7,2.029c-.02.1-.047.189-.063.286a2.81,2.81,0,0,0,1.651,2.823s.654.368,1.276.673c1.479.723,3.763,1.642,4.657,1.554.213-.013.421-.044.622-.07a6.555,6.555,0,0,0,2.018-.722l13.676-8.782,1.17-.752,12.506-8.031a3.394,3.394,0,0,0,1.722-2.328c0-.231.23-1,.283-1.744.114-1.578.688-3.917.282-5.451C308.071,237.4,307.99,236.563,307.743,236.421Z",
    transform: "translate(-265.628 -233.127)",
    opacity: 0.273
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11280",
    "data-name": "Path 11280",
    d: "M308.358,238.411c-.136.023-1.342-.389-1.467-.358-1.443-.2-3.429,4.679-4.57,4.76a7.808,7.808,0,0,0-2.54.813L285.969,251.6l-13.825,7.982a4.131,4.131,0,0,0-1.686,1.891c-.022.09-.056.175-.077.264a2.525,2.525,0,0,0,1.5,2.707s.669.387,1.213.655c1.41.694,3.568,1.516,4.465,1.4.2-.017.4-.055.591-.083a7.042,7.042,0,0,0,1.911-.728l13.061-8.412,1.118-.72,11.943-7.692c.709-.409,1.712-1.454,1.712-2.173,0-.2.306-.962.376-1.611.156-1.459.946-3.635.515-5.076C308.608,239.414,308.575,238.536,308.358,238.411Z",
    transform: "translate(-266.704 -234.263)",
    opacity: 0.364
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11281",
    "data-name": "Path 11281",
    d: "M308.965,240.4c-.17.029-1.255-.313-1.411-.275-1.54-.1-3.455,4.236-4.549,4.338a8.684,8.684,0,0,0-2.412.832l-13.222,7.634-13.238,7.643a4.617,4.617,0,0,0-1.674,1.754c-.024.084-.065.161-.091.243a2.254,2.254,0,0,0,1.345,2.591s.683.407,1.149.638c1.339.664,3.373,1.39,4.272,1.244.193-.021.378-.065.559-.095a7.731,7.731,0,0,0,1.8-.735l12.445-8.041,1.066-.688,11.381-7.353c.607-.351,1.7-1.4,1.7-2.019,0-.173.386-.925.468-1.478.2-1.348,1.207-3.348.749-4.7C309.138,241.428,309.15,240.5,308.965,240.4Z",
    transform: "translate(-267.771 -235.394)",
    opacity: 0.455
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11282",
    "data-name": "Path 11282",
    d: "M309.562,242.378c-.2.035-1.168-.238-1.356-.192-1.638.007-3.479,3.793-4.528,3.915a9.994,9.994,0,0,0-2.284.851l-12.632,7.293-12.651,7.3c-.454.262-1.609,1.166-1.663,1.616a1.968,1.968,0,0,0-.105.222c-.358.861.059,1.822,1.192,2.476,0,0,.7.427,1.086.62a8.686,8.686,0,0,0,4.079,1.089c.183-.025.357-.076.528-.107a8.762,8.762,0,0,0,1.7-.742l11.83-7.671,1.013-.657,10.817-7.014c.506-.292,1.692-1.35,1.692-1.864,0-.145.563-.879.56-1.345.483-1.171,1.7-3.168.983-4.328C309.743,243.412,309.717,242.467,309.562,242.378Z",
    transform: "translate(-268.829 -236.519)",
    opacity: 0.545
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11283",
    "data-name": "Path 11283",
    d: "M310.15,244.356c-.238.041-1.082-.163-1.3-.109-1.735.109-3.5,3.349-4.508,3.492a11.965,11.965,0,0,0-2.155.87l-12.041,6.952-12.063,6.965c-.363.21-1.609,1.118-1.652,1.478a1.891,1.891,0,0,0-.119.2c-.423.8-.059,1.726,1.039,2.36,0,0,.712.447,1.022.6a7.5,7.5,0,0,0,3.887.934c.173-.03.335-.087.5-.119a10.372,10.372,0,0,0,1.591-.748l11.215-7.3.961-.625,10.254-6.675c.405-.234,1.682-1.3,1.682-1.71,0-.115.655-.839.653-1.212.565-1.04,1.994-2.907,1.216-3.953C310.265,245.414,310.274,244.427,310.15,244.356Z",
    transform: "translate(-269.878 -237.642)",
    opacity: 0.636
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11284",
    "data-name": "Path 11284",
    d: "M310.73,246.33c-.272.046-.995-.087-1.245-.026-1.832.212-3.522,2.906-4.487,3.07a15.381,15.381,0,0,0-2.026.89l-11.45,6.611L280.044,263.5c-.272.157-1.608,1.07-1.64,1.34a1.806,1.806,0,0,0-.133.18c-.49.733-.177,1.631.886,2.245,0,0,.727.467.958.585a6.478,6.478,0,0,0,3.695.779c.163-.034.313-.1.465-.132a13.32,13.32,0,0,0,1.484-.754l10.6-6.929.908-.594,9.692-6.336c.3-.175,1.672-1.246,1.672-1.555,0-.087.747-.8.746-1.079.647-.909,2.291-2.645,1.449-3.579A9.962,9.962,0,0,0,310.73,246.33Z",
    transform: "translate(-270.918 -238.762)",
    opacity: 0.727
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11285",
    "data-name": "Path 11285",
    d: "M311.3,248.264c-.307.052-.908-.011-1.19.058-1.93.314-3.594,2.284-4.467,2.647a14.076,14.076,0,0,0-1.9.909l-10.861,6.271L282,264.434a8.818,8.818,0,0,0-1.628,1.2,1.775,1.775,0,0,0-.148.158c-.558.668-.3,1.535.733,2.129,0,0,.741.489.895.569a5.609,5.609,0,0,0,3.5.623c.153-.039.291-.108.434-.144s1.257-.691,1.377-.761l9.984-6.559.856-.562,9.129-6c.2-.117,1.662-1.195,1.662-1.4,0-.058.839-.76.838-.946.729-.778,2.587-2.384,1.682-3.205C311.282,249.368,311.363,248.3,311.3,248.264Z",
    transform: "translate(-271.949 -239.84)",
    opacity: 0.818
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11286",
    "data-name": "Path 11286",
    d: "M311.864,250.147c-.341.058-.821.064-1.134.141-2.027.416-3.625,1.82-4.447,2.225-.106,0-1.693.884-1.769.928l-10.27,5.93-10.3,5.948a16.521,16.521,0,0,0-1.617,1.064,1.7,1.7,0,0,0-.162.138c-.627.6-.414,1.439.58,2.013,0,0,.754.511.831.551a4.858,4.858,0,0,0,3.309.469,2.535,2.535,0,0,0,.4-.157c.08-.008,1.21-.732,1.271-.767l9.368-6.188.8-.531,8.566-5.658A14.847,14.847,0,0,0,308.947,255a10.422,10.422,0,0,0,.931-.813c.811-.647,2.884-2.122,1.916-2.83C311.778,251.275,311.9,250.165,311.864,250.147Z",
    transform: "translate(-272.973 -240.868)",
    opacity: 0.909
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11287",
    "data-name": "Path 11287",
    d: "M288.782,269.819l10.668-7.091,10.668-7.091c.894-.516,3.182-1.86,2.149-2.456l.153-1.151a16.448,16.448,0,0,0-5.5,2.026l-11.32,6.536-11.32,6.535c-.894.516-.782,1.418.251,2.014l.767.533A3.875,3.875,0,0,0,288.782,269.819Z",
    transform: "translate(-273.99 -241.896)"
  }))), _g267 || (_g267 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3936",
    "data-name": "Group 3936",
    transform: "translate(19.408 10.381)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11288",
    "data-name": "Path 11288",
    d: "M307.576,250.707a2.74,2.74,0,0,1-1.243,2.145c-.687.4-1.243.079-1.243-.709A2.74,2.74,0,0,1,306.332,250C307.019,249.6,307.576,249.919,307.576,250.707Z",
    transform: "translate(-305.089 -242.549)",
    fill: "url(#linear-gradient-62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11289",
    "data-name": "Path 11289",
    d: "M314.638,246.7a2.74,2.74,0,0,1-1.243,2.145c-.687.4-1.243.079-1.243-.709a2.74,2.74,0,0,1,1.243-2.145C314.081,245.594,314.638,245.912,314.638,246.7Z",
    transform: "translate(-308.944 -240.361)",
    fill: "url(#linear-gradient-62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11290",
    "data-name": "Path 11290",
    d: "M321.7,242.693a2.739,2.739,0,0,1-1.244,2.145c-.687.4-1.243.079-1.243-.709a2.74,2.74,0,0,1,1.243-2.145C321.143,241.587,321.7,241.9,321.7,242.693Z",
    transform: "translate(-312.799 -238.174)",
    fill: "url(#linear-gradient-62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11291",
    "data-name": "Path 11291",
    d: "M328.763,238.686a2.74,2.74,0,0,1-1.243,2.145c-.687.4-1.243.079-1.243-.709a2.74,2.74,0,0,1,1.243-2.145C328.206,237.58,328.763,237.9,328.763,238.686Z",
    transform: "translate(-316.655 -235.986)",
    fill: "url(#linear-gradient-62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11292",
    "data-name": "Path 11292",
    d: "M335.825,234.679a2.739,2.739,0,0,1-1.243,2.145c-.687.4-1.243.079-1.243-.709a2.74,2.74,0,0,1,1.243-2.145C335.268,233.573,335.825,233.891,335.825,234.679Z",
    transform: "translate(-320.51 -233.799)",
    fill: "url(#linear-gradient-62)"
  }))))), _g268 || (_g268 = /*#__PURE__*/React.createElement("g", {
    id: "dot_group-2",
    "data-name": "dot group",
    transform: "translate(1213.053 -301.78)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse1_2",
    "data-name": "Ellipse1 ",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(398.934 331.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse2-2",
    "data-name": "Ellipse2",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(410.934 331.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3-2",
    "data-name": "Ellipse 3",
    cx: 1,
    cy: 1.5,
    rx: 1,
    ry: 1.5,
    transform: "translate(423.934 331.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse4-2",
    "data-name": "Ellipse4",
    cx: 1,
    cy: 1.5,
    rx: 1,
    ry: 1.5,
    transform: "translate(399.934 343.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse5-2",
    "data-name": "Ellipse5",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(410.934 343.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse6-2",
    "data-name": "Ellipse6",
    cx: 1,
    cy: 1.5,
    rx: 1,
    ry: 1.5,
    transform: "translate(423.934 343.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse7-2",
    "data-name": "Ellipse7",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(399.934 356.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse8-2",
    "data-name": "Ellipse8",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(410.934 356.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse9-2",
    "data-name": "Ellipse9",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(423.934 356.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse10-2",
    "data-name": "Ellipse10",
    cx: 2,
    cy: 1.5,
    rx: 2,
    ry: 1.5,
    transform: "translate(399.934 368.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse11-2",
    "data-name": "Ellipse11",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(411.934 368.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse12-2",
    "data-name": "Ellipse12",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(423.934 368.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse13-2",
    "data-name": "Ellipse13",
    cx: 2,
    cy: 1.5,
    rx: 2,
    ry: 1.5,
    transform: "translate(399.934 380.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse14-2",
    "data-name": "Ellipse14",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(411.934 380.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse15-2",
    "data-name": "Ellipse15",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(423.934 380.78)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3477-2",
    "data-name": "Group 3477",
    transform: "translate(48.119 174.836)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3476-2",
    "data-name": "Group 3476",
    style: {
      isolation: "isolate"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10650-2",
    "data-name": "Path 10650",
    d: "M121.047,226.488c-.118-.207-.261-5.285-.261-5.285l.293-.323.151,1.082Z",
    transform: "translate(-83.933 -209.326)",
    fill: "url(#linear-gradient-13)"
  })), _g269 || (_g269 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3450-2",
    "data-name": "Group 3450",
    transform: "translate(30.62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10651-2",
    "data-name": "Path 10651",
    d: "M117.682,217.374l.014,5.073.092-2.248-.014-5.073Z",
    transform: "translate(-117.682 -215.126)",
    fill: "url(#linear-gradient-13)"
  }))), _g270 || (_g270 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3451-2",
    "data-name": "Group 3451",
    transform: "translate(44.449 6.263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10652-2",
    "data-name": "Path 10652",
    d: "M124.569,219.827l.014,5.073,2.741-1.583-.014-5.072Z",
    transform: "translate(-124.569 -218.245)",
    fill: "url(#linear-gradient-13)"
  }))), _g271 || (_g271 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3452-2",
    "data-name": "Group 3452",
    transform: "translate(4.143 6.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10653-2",
    "data-name": "Path 10653",
    d: "M104.5,218.347l.014,5.073,2.763,1.56-.014-5.072Z",
    transform: "translate(-104.495 -218.347)",
    fill: "url(#linear-gradient-13)"
  }))), _g272 || (_g272 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3453-2",
    "data-name": "Group 3453",
    transform: "translate(21.123 7.622)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10654-2",
    "data-name": "Path 10654",
    d: "M112.952,219.442l.014,5.074a21.021,21.021,0,0,1,9.108-.046l-.014-5.072A21.053,21.053,0,0,0,112.952,219.442Z",
    transform: "translate(-112.952 -218.922)",
    fill: "url(#linear-gradient-13)"
  }))), _g273 || (_g273 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3454-2",
    "data-name": "Group 3454",
    transform: "translate(30.231 8.098)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10655-2",
    "data-name": "Path 10655",
    d: "M117.488,219.159l.014,5.073.316.092-.014-5.073Z",
    transform: "translate(-117.488 -219.159)",
    fill: "url(#linear-gradient-13)"
  }))), _g274 || (_g274 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3455-2",
    "data-name": "Group 3455",
    transform: "translate(20.765 8.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10656-2",
    "data-name": "Path 10656",
    d: "M112.774,219.3l.014,5.073.357-.115-.014-5.073Z",
    transform: "translate(-112.774 -219.181)",
    fill: "url(#linear-gradient-13)"
  }))), _g275 || (_g275 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3456-2",
    "data-name": "Group 3456",
    transform: "translate(30.548 8.189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10657-2",
    "data-name": "Path 10657",
    d: "M117.646,219.2l.014,5.074a14.912,14.912,0,0,1,3.833,1.444l-.014-5.072A14.871,14.871,0,0,0,117.646,219.2Z",
    transform: "translate(-117.646 -219.204)",
    fill: "url(#linear-gradient-13)"
  }))), _g276 || (_g276 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3457-2",
    "data-name": "Group 3457",
    transform: "translate(34.381 9.634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10658-2",
    "data-name": "Path 10658",
    d: "M119.555,219.924l.014,5.072a8.663,8.663,0,0,1,2.6,2.249l-.014-5.072A8.608,8.608,0,0,0,119.555,219.924Z",
    transform: "translate(-119.555 -219.924)",
    fill: "url(#linear-gradient-13)"
  }))), _g277 || (_g277 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3458-2",
    "data-name": "Group 3458",
    transform: "translate(14.288 8.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10659-2",
    "data-name": "Path 10659",
    d: "M109.548,222.979l.016,5.072a7.911,7.911,0,0,1,2.626-2.249,13.8,13.8,0,0,1,3.849-1.49l-.014-5.074a13.815,13.815,0,0,0-3.851,1.492A7.905,7.905,0,0,0,109.548,222.979Z",
    transform: "translate(-109.548 -219.238)",
    fill: "url(#linear-gradient-13)"
  }))), _g278 || (_g278 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3459-2",
    "data-name": "Group 3459",
    transform: "translate(13.634 10.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10660-2",
    "data-name": "Path 10660",
    d: "M109.222,221.808l.47,5.074a53.915,53.915,0,0,0,.765-6.279Z",
    transform: "translate(-109.222 -220.603)",
    fill: "url(#linear-gradient-13)"
  }))), _g279 || (_g279 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3460-2",
    "data-name": "Group 3460",
    transform: "translate(37.1 12.056)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10661-2",
    "data-name": "Path 10661",
    d: "M121.766,228.734l-.016-5.072a4.375,4.375,0,0,0-.841-2.532l.014,5.106A4.287,4.287,0,0,1,121.766,228.734Z",
    transform: "translate(-120.909 -221.13)",
    fill: "url(#linear-gradient-13)"
  }))), _g280 || (_g280 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3461-2",
    "data-name": "Group 3461",
    transform: "translate(13.164 12.203)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10662-2",
    "data-name": "Path 10662",
    d: "M108.988,223.865l.014,5.072a4.425,4.425,0,0,1,.926-2.66l-.014-5.074A4.431,4.431,0,0,0,108.988,223.865Z",
    transform: "translate(-108.988 -221.203)",
    fill: "url(#linear-gradient-13)"
  }))), _g281 || (_g281 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3462-2",
    "data-name": "Group 3462",
    transform: "translate(51.009 11.791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10663-2",
    "data-name": "Path 10663",
    d: "M127.836,226.664l.014,5.073.072-5.666L127.908,221Z",
    transform: "translate(-127.836 -220.998)",
    fill: "url(#linear-gradient-13)"
  }))), _g282 || (_g282 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3463-2",
    "data-name": "Group 3463",
    transform: "translate(47.167 17.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10664-2",
    "data-name": "Path 10664",
    d: "M125.923,223.843l.014,5.073,3.841-.023-.014-5.073Z",
    transform: "translate(-125.923 -223.82)",
    fill: "url(#linear-gradient-13)"
  }))), _g283 || (_g283 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3464-2",
    "data-name": "Group 3464",
    transform: "translate(0 17.709)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10665-2",
    "data-name": "Path 10665",
    d: "M102.432,223.968l.014,5.073,3.841-.023-.014-5.073Z",
    transform: "translate(-102.432 -223.945)",
    fill: "url(#linear-gradient-13)"
  }))), _g284 || (_g284 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3465-2",
    "data-name": "Group 3465",
    transform: "translate(44.254 17.479)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10666-2",
    "data-name": "Path 10666",
    d: "M124.472,227.845l.014,5.074A11.791,11.791,0,0,0,127.4,228.9l-.014-5.072A11.785,11.785,0,0,1,124.472,227.845Z",
    transform: "translate(-124.472 -223.831)",
    fill: "url(#linear-gradient-13)"
  }))), _g285 || (_g285 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3466-2",
    "data-name": "Group 3466",
    transform: "translate(3.841 17.708)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10667-2",
    "data-name": "Path 10667",
    d: "M104.345,223.945l.014,5.074a11.1,11.1,0,0,0,2.829,3.99l-.014-5.072A11.079,11.079,0,0,1,104.345,223.945Z",
    transform: "translate(-104.345 -223.945)",
    fill: "url(#linear-gradient-13)"
  }))), _g286 || (_g286 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3467-2",
    "data-name": "Group 3467",
    transform: "translate(39.945 23.077)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10668-2",
    "data-name": "Path 10668",
    d: "M122.326,230.679l.014,5.073,7.032-4.06-.014-5.073Z",
    transform: "translate(-122.326 -226.619)",
    fill: "url(#linear-gradient-13)"
  }))), _g287 || (_g287 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3468-2",
    "data-name": "Group 3468",
    transform: "translate(37.221 25.554)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10669-2",
    "data-name": "Path 10669",
    d: "M120.97,227.853l.014,5.073,2.723,1.583-.014-5.073Z",
    transform: "translate(-120.97 -227.853)",
    fill: "url(#linear-gradient-13)"
  }))), _g288 || (_g288 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3469-2",
    "data-name": "Group 3469",
    transform: "translate(10.797 25.692)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10670-2",
    "data-name": "Path 10670",
    d: "M107.809,229.5l.014,5.073,2.741-1.583-.014-5.073Z",
    transform: "translate(-107.809 -227.921)",
    fill: "url(#linear-gradient-13)"
  }))), _g289 || (_g289 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3470-2",
    "data-name": "Group 3470",
    transform: "translate(3.889 23.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10671-2",
    "data-name": "Path 10671",
    d: "M104.369,226.733l.014,5.073,6.908,3.968-.014-5.073Z",
    transform: "translate(-104.369 -226.733)",
    fill: "url(#linear-gradient-13)"
  }))), _g290 || (_g290 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3471-2",
    "data-name": "Group 3471",
    transform: "translate(30.281 25.553)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10672-2",
    "data-name": "Path 10672",
    d: "M117.513,229.527l.016,5.074a31.989,31.989,0,0,0,6.939-1.675l-.014-5.074A31.981,31.981,0,0,1,117.513,229.527Z",
    transform: "translate(-117.513 -227.852)",
    fill: "url(#linear-gradient-13)"
  }))), _g291 || (_g291 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3472-2",
    "data-name": "Group 3472",
    transform: "translate(13.539 25.692)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10673-2",
    "data-name": "Path 10673",
    d: "M109.175,227.921l.014,5.072a33.723,33.723,0,0,0,6.921,1.584L116.1,229.5A33.561,33.561,0,0,1,109.175,227.921Z",
    transform: "translate(-109.175 -227.921)",
    fill: "url(#linear-gradient-13)"
  }))), _g292 || (_g292 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3473-2",
    "data-name": "Group 3473",
    transform: "translate(30.229 27.229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10674-2",
    "data-name": "Path 10674",
    d: "M117.487,230.911l.014,5.073.052-2.225-.014-5.073Z",
    transform: "translate(-117.487 -228.686)",
    fill: "url(#linear-gradient-13)"
  }))), _g293 || (_g293 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3474-2",
    "data-name": "Group 3474",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10675-2",
    "data-name": "Path 10675",
    d: "M106.273,232.834l-3.841.024.072-5.666,3.881-.046a11.254,11.254,0,0,1,2.952-3.992l-2.763-1.56,7.034-4.06,2.723,1.582a34.1,34.1,0,0,1,6.939-1.719l.012-2.2,9.863-.068-.092,2.247A31.824,31.824,0,0,1,139.973,219l2.781-1.6,6.869,3.992-2.743,1.582a10.916,10.916,0,0,1,2.791,3.968l3.841-.022-.072,5.666-3.841.022a11.785,11.785,0,0,1-2.913,4.014l2.723,1.584-7.032,4.06-2.723-1.584a31.979,31.979,0,0,1-6.941,1.675l-.052,2.227-9.821.044.052-2.225a33.563,33.563,0,0,1-6.921-1.582l-2.743,1.582-6.907-3.968,2.781-1.606A11.079,11.079,0,0,1,106.273,232.834ZM123,236.482l.355.068a20.7,20.7,0,0,0,9.11-.046l.355-.068a16.486,16.486,0,0,0,3.851-1.536,9.351,9.351,0,0,0,2.785-2.434,4.5,4.5,0,0,0-.048-5.457,8.608,8.608,0,0,0-2.6-2.249,14.872,14.872,0,0,0-3.833-1.446l-.317-.09a21.052,21.052,0,0,0-9.108.044l-.357.114a13.815,13.815,0,0,0-3.851,1.492,8.836,8.836,0,0,0-2.825,2.454,4.454,4.454,0,0,0,.048,5.459,8.336,8.336,0,0,0,2.562,2.181A15.293,15.293,0,0,0,123,236.482Z",
    transform: "translate(-102.432 -215.126)",
    fill: "url(#linear-gradient-13)"
  }))), _g294 || (_g294 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3475-2",
    "data-name": "Group 3475",
    transform: "translate(20.408 29.454)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10676-2",
    "data-name": "Path 10676",
    d: "M112.6,229.84l.014,5.073,9.821-.046-.014-5.073Z",
    transform: "translate(-112.596 -229.795)",
    fill: "url(#linear-gradient-13)"
  }))))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "isomatric_coin-2",
    "data-name": "isomatric coin",
    d: "M26.916,13.351a8.06,8.06,0,0,1,.8,3.278,4.224,4.224,0,0,1-3.021,4.236,8.06,8.06,0,0,1-3.359.314M15.167,6.257a5.477,5.477,0,0,0-2.748,1.094,4.015,4.015,0,0,0-1.4,2.255,6.151,6.151,0,0,0,.156,3.074A11.653,11.653,0,0,0,12.862,16.1m21.054-1.068c3.392,7.44-.457,12.837-8.6,12.055S7.832,19.642,4.44,12.2,4.9-.636,13.036.147,30.524,7.6,33.916,15.036Zm-.273-.465c4.2,7.79.588,16.113-8.26,15.859S5.953,23.654,1.749,15.865,1.161-.248,10.009.006,29.438,6.781,33.642,14.571Z",
    transform: "translate(179.486 117.693)",
    fill: "none",
    stroke: "#fbb516",
    strokeWidth: 1.5
  })), _g295 || (_g295 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2743-2",
    "data-name": "Group 2743",
    transform: "translate(129.979 31.621) rotate(-29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9767-2",
    "data-name": "Path 9767",
    d: "M7.9,1.328,1.013,7.2,0,0Z",
    transform: "translate(14.994 33.027)",
    fill: "url(#linear-gradient-49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9768-2",
    "data-name": "Path 9768",
    d: "M.5,0,0,32.509A2.307,2.307,0,0,0,2.341,34.85l32.644-.72a.913.913,0,0,0,.608-1.576Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-50)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9769-2",
    "data-name": "Path 9769",
    d: "M22.4,34.355,0,0,17.133,34.49,15.287,36.2Z",
    transform: "translate(0.495 0)",
    fill: "url(#linear-gradient-51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9770-2",
    "data-name": "Path 9770",
    d: "M0,.067,1.508,5.741,3.129,0Z",
    transform: "translate(14.498 34.49)",
    fill: "url(#linear-gradient-49)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/Banner.4ba5abc9b589c3b7f939e38097616605.svg";
export { ForwardRef as ReactComponent };